<template>
  <div>
    <!-- ShopUsers nascosto: usato solo per la scheda cliente -->
    <shop-users ref="shopUsersRef" :shopID="selectedShop" style="display:none" @crmClientDeleted="onCrmClientDeleted"></shop-users>

    <!-- Popup aggiungi nota cliente -->
    <v-dialog v-model="addNoteDialog" max-width="420" persistent style="z-index: 9999">
      <v-card>
        <v-toolbar color="red lighten-2" dark dense>
          <v-toolbar-title>{{ getString("Aggiungi nota") }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="addNoteDialog = false"><v-icon>close</v-icon></v-btn>
        </v-toolbar>
        <v-card-text style="padding-top: 16px">
          <v-text-field v-model="newNoteAuthor" :label="getString('Autore (facoltativo)')" color="red lighten-2" />
          <v-textarea v-model="newNoteText" :label="getString('Nota')" color="red lighten-2" rows="4" auto-grow />
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click="addNoteDialog = false">{{ getString("Annulla") }}</v-btn>
          <v-btn class="q-orange-bk q-text-whitesmoke" :loading="isSavingNote" @click="addNote">
            <v-icon left small>save</v-icon>{{ getString("Salva") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog lista clienti -->
    <v-dialog v-model="openClientsList" :fullscreen="$vuetify.breakpoint.smAndDown" max-width="1200" scrollable>
      <v-card>
        <v-card-text style="padding: 0">
          <shop-users v-if="openClientsList" :shopID="selectedShop" @siteAlert="siteAlert" @siteAlertSuccess="siteAlertSuccess"></shop-users>
        </v-card-text>
        <v-card-actions style="justify-content: flex-end;">
          <v-btn class="q-orange q-whitesmoke-bk bold" @click="openClientsList = false">{{ getString("Chiudi") }}</v-btn> 
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog Gestisci Ferie -->
    <v-dialog v-model="showFerieDialog" v-show="showFerieDialog" max-width="590" eager>
      <v-card>
        <v-toolbar class="q-orange-bk q-text-whitesmoke" height="50px">
          <v-toolbar-title>{{ getString("Assenza collaboratore") }}</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <v-layout row wrap>
            <v-flex xs12>
              <v-select
                :items="emps"
                v-model="ferieEmpId"
                item-text="employees.name"
                item-value="employees.idEmployee"
                :label="getString('Dipendente')"
                :menu-props="{ bottom: true, offsetY: true }"
                solo
              ></v-select>
            </v-flex>
            <v-flex xs12>
              <h3>{{ getString("Inserisci un intervallo di giorni in cui il dipendente è assente") }}</h3>
            </v-flex>
            <v-flex xs6>
              <v-menu
                ref="ferieDp1"
                :close-on-content-click="false"
                v-model="ferieDp1"
                :nudge-right="40"
                :return-value.sync="ferieDateStart"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="ferieDateStart"
                  :label="getString('Da')"
                  prepend-icon="event"
                  readonly
                  color="red lighten-2"
                ></v-text-field>
                <v-date-picker
                  :locale="locale"
                  :title-date-format="formatTitle"
                  show-current
                  color="red lighten-2"
                  v-model="ferieDateStart"
                  @input="$refs.ferieDp1.save(ferieDateStart)"
                ></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex xs6>
              <v-menu
                ref="ferieDp2"
                :close-on-content-click="false"
                v-model="ferieDp2"
                :nudge-right="40"
                :return-value.sync="ferieDateEnd"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="ferieDateEnd"
                  :label="getString('A')"
                  prepend-icon="event"
                  readonly
                  color="red lighten-2"
                ></v-text-field>
                <v-date-picker
                  :locale="locale"
                  :title-date-format="formatTitle"
                  show-current
                  color="red lighten-2"
                  v-model="ferieDateEnd"
                  @input="$refs.ferieDp2.save(ferieDateEnd)"
                ></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex xs12>
              <h3>{{ getString("Se hai un messaggio da comunicare ai tuoi clienti riguardo al motivo per cui questo collaboratore è assente, ti preghiamo di inserirlo.") }}</h3>
              <label>{{ getString("Messaggio") }}</label>
              <editor
                v-if="ferieShowEditor"
                api-key="vn43j4ndioj2ysq09jicr7yfha8fvqcp8kye03mrgsixspv4"
                v-bind:label="getString('Messaggio da comunicare')"
                v-model="ferieMessage"
                :init="{
                  selector: 'textarea',
                  language_url: '../../static/languages/tinymce/it.js',
                  menubar: false,
                  min_height: 200,
                  branding: false,
                }"
              ></editor>
            </v-flex>
            <v-flex xs12>
              <v-divider style="margin: 16px 0 8px;"></v-divider>
              <h3 style="margin-bottom: 8px;">{{ getString("Ferie programmate") }}</h3>
              <v-progress-linear v-if="ferieListLoading" indeterminate color="red" :height="2"></v-progress-linear>
              <div v-if="!ferieListLoading && ferieList.length === 0" style="color: grey; font-style: italic; margin-bottom: 8px;">
                {{ getString("Nessuna ferie programmata") }}
              </div>
              <div v-if="!ferieListLoading && ferieList.length > 0">
                <div
                  v-for="(range, idx) in ferieList"
                  :key="idx"
                  style="display: flex; align-items: center; border-bottom: solid thin #eee; padding: 8px 0;"
                >
                  <div style="flex: 1; overflow: hidden;">
                    <div><strong>{{ range.from === range.to ? ut.itaDate(range.from) : (ut.itaDate(range.from) + ' → ' + ut.itaDate(range.to)) }}</strong></div>
                    <div v-if="range.message" style="margin-top: 2px;">
                      <div style="font-size: 12px; color: grey; overflow: hidden; display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical;" v-html="range.message"></div>
                      <a href="#" style="font-size: 11px;" @click.prevent="() => { ferieMessagePopup = range.message; showFerieMessagePopup = true; }">{{ getString("Leggi tutto") }}</a>
                    </div>
                  </div>
                  <div style="flex-shrink: 0;">
                    <v-tooltip top>
                      <v-btn slot="activator" icon flat color="red" @click="() => deleteFerieRange(range.from, range.to)">
                        <v-icon>delete</v-icon>
                      </v-btn>
                      <span>{{ getString("Elimina") }}</span>
                    </v-tooltip>
                  </div>
                </div>
              </div>
            </v-flex>
            <v-flex xs12>
              <v-progress-linear
                v-if="ferieIsDisabling"
                indeterminate
                :active="true"
                color="red"
                :height="2"
              ></v-progress-linear>
            </v-flex>
            <v-flex xs12 style="text-align: right;">
              <v-btn :disabled="ferieIsDisabling" @click="() => { showFerieDialog = false; ferieShowEditor = false; ferieList = []; }" class="q-orange q-whitesmoke-bk bold">
                {{ getString("Chiudi") }}
              </v-btn>
              <v-btn :disabled="ferieIsDisabling" :loading="ferieIsDisabling" @click="() => saveFerieFromCalendar()" class="q-orange-bk q-text-whitesmoke bold">
                {{ getString("Salva assenza") }}
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- Dialog messaggio ferie completo -->
    <v-dialog v-model="showFerieMessagePopup" max-width="500">
      <v-card>
        <v-toolbar class="q-orange-bk q-text-whitesmoke" height="50px">
          <v-toolbar-title>{{ getString("Messaggio") }}</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <div v-html="ferieMessagePopup" style="margin-top: 8px;"></div>
        </v-card-text>
        <v-card-actions style="justify-content: flex-end;">
          <v-btn class="q-orange q-whitesmoke-bk bold" @click="showFerieMessagePopup = false">{{ getString("Chiudi") }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Fine Dialog messaggio ferie completo -->

    <!-- Conferma eliminazione nota -->
    <!-- <v-dialog v-model="confirmDeleteNoteDialog" max-width="360">
      <v-card>
        <v-card-title class="headline">{{ getString("Elimina nota") }}</v-card-title>
        <v-card-text>{{ getString("Sei sicuro di voler eliminare questa nota?") }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click="confirmDeleteNoteDialog = false">{{ getString("Annulla") }}</v-btn>
          <v-btn color="red darken-1" dark @click="deleteGlobalNote(pendingDeleteNoteId); confirmDeleteNoteDialog = false">{{ getString("Elimina") }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog> -->
    <!-- Fine Dialog Gestisci Ferie -->
    <div v-if="!isExpired">
      <div>
        <div class="feature-list">
          <v-list>
            <v-badge color="red" overlap v-model="waitingListExist">
              <template v-slot:badge>
                <span>{{ waitingList.length }}</span>
              </template>
              <v-tooltip right>
                <v-btn
                  slot="activator"
                  class="mx-2"
                  fab
                  dark
                  small
                  color="red"
                  @click="() => (openWaitingList = true)"
                >
                  <v-icon dark>alarm</v-icon>
                </v-btn>

                <span
                  >Visualizza la lista degli utenti in attesa di un posto</span
                >
              </v-tooltip>
            </v-badge>
            <v-tooltip right>
              <v-btn
                slot="activator"
                class="mx-2"
                fab
                dark
                small
                color="blue"
                @click="() => (openSearchUser = true)"
              >
                <v-icon dark>search</v-icon>
              </v-btn>
              <span>Cerca tutte le prenotazioni effettuate da un utente</span>
            </v-tooltip>
            <v-tooltip right>
              <v-btn
                slot="activator"
                class="mx-2"
                fab
                dark
                small
                color="orange"
                @click="
                  () => {
                    getNotificationUsers();
                    openNotificationRead = true;
                  }
                "
              >
                <v-icon dark>campaign</v-icon>
              </v-btn>
              <span>Visualizza tutte le notifiche inviate</span>
            </v-tooltip>
            <v-tooltip right>
              <v-btn
                slot="activator"
                class="mx-2"
                fab
                dark
                small
                color="red"
                @click="() => handleShowFerieDialog()"
              >
                <v-icon dark>face</v-icon>
              </v-btn>
              <span>Gestisci ferie collaboratore</span>
            </v-tooltip>
            <v-tooltip right>
              <v-btn
                slot="activator"
                class="mx-2"
                fab
                dark
                small
                color="teal"
                @click="() => (openClientsList = true)"
              >
                <v-icon dark>people</v-icon>
              </v-btn>
              <span>Lista clienti</span>
            </v-tooltip>
          </v-list>
        </div>
      </div>

      <!-- Pulsante impostazioni ancorato in basso a sinistra -->
      <div class="settings-btn-fixed">
        <v-tooltip right>
          <v-btn
            slot="activator"
            fab
            dark
            small
            color="grey"
            @click="
              () => {
                initialSwitchState = {
                  serviceColor: serviceColor,
                };
                openSettingsModel = true;
              }
            "
          >
            <v-icon dark>settings</v-icon>
          </v-btn>
          <span>Impostazioni calendario</span>
        </v-tooltip>
      </div>
      <div v-if="!isExpired || isAdmin" id="cal-container">
        <v-layout
          v-if="mainLoad"
          style="background-color: transparent; height: 83vh; display: block"
          xs12
          justify-center
          align-content-center
        >
          <!--
          <v-progress-circular color="red ligthen-2" style="background-color:transparent; margin:auto" indeterminate :size="150" :width="1" />
        -->
          <progress-q></progress-q>
        </v-layout>
        <v-layout row v-if="toPublish" v-show="!mainLoad">
          <v-alert
            :value="true"
            type="warning"
            color="orange darken-2"
            style="width: 100%"
          >
            <span
              v-html="
                getString(
                  'Ora sei nel mondo di <b>QuickBe</b>, ma il tuo negozio non è ancora pubblicato. Completa la configurazione e poi premi sul bottone <b>PUBBLICA</b> nella sezione negozio. :)'
                )
              "
            ></span>
          </v-alert>
        </v-layout>
         <v-layout
          row
          v-if="true"
          v-show="!mainLoad"
        >
          <v-alert
            :value="showNewPanelDialog"
            type="warning"
            color="orange darken-2"
            style="width: 100%;padding:5px;margin-bottom: 20px"
          >
            <div class="new-panel-alert-row">
              <span
              style="align-self:center"
                v-html="
                  getString(
                    'Il nuovo pannello è online, provalo subito! Non perderti le nuove funzionalità come la turnazione dipendenti o il magazzino'
                  )
                "
              ></span>
               <v-btn
                small
                color="white"
                class="bold center-btn"
                 @click="handleActivateNewPanel"
              >
                Visualizza il nuovo pannello
              </v-btn>
              <v-btn
                icon
                small
                color="white"
                  @click="showNewPanelDialog = false"
              
              >
                <v-icon small>close</v-icon>
              </v-btn>
            </div>
          </v-alert>
        </v-layout>
        <v-layout
          row
          v-if="expiringDays < 15 && expiringDays !== 0"
          v-show="!mainLoad"
          style="margin-bottom: 20px"
        >
          <v-alert
            :value="showExpiredDialog"
            type="warning"
            color="orange darken-2"
            style="width: 100%;padding:5px"
          >
            <div style="display: flex; justify-content: space-between; align-items: flex-start; gap: 12px;">
              <span
              style="align-self:center"
                v-html="
                  getString(
                    'Attenzione: Il tuo abbonamento scadrà fra ' +
                      expiringDays +
                      ' giorni. Rinnovalo subito!'
                  )
                "
              ></span>
              <v-btn
                icon
                small
                color="white"
                @click="showExpiredDialog = false"
              >
                <v-icon small>close</v-icon>
              </v-btn>
            </div>
          </v-alert>
        </v-layout>
        <div
          v-show="!mainLoad"
          class="main-headers"
          :class="{ 'main-headers-full': isFullscreen }"
          ref="header"
        >
          <template v-for="(item0, index0) in days">
            <div
              :key="index0"
              class="header-item"
              v-if="!isClosed(item0.dayOfWeek)"
              :style="{ width: headerWidth + 'px' }"
            >
              <div style="text-align: center">
                <h3>
                  {{ getDayName(item0.dayOfWeek, item0.day.split("T")[0]) }}
                  <v-icon v-if="!item0.isBookable">phonelink_erase</v-icon>
                </h3>
              </div>
            </div>
          </template>
        </div>
        <div
          v-show="!mainLoad"
          class="main-flex"
          :class="{ 'main-flex-full': isFullscreen }"
          @scroll="scroll"
          ref="mainFlex"
        >
          <template v-for="(item0, index0) in days">
            <div :key="index0" v-if="!isClosed(item0.dayOfWeek).times">
              <div
                class="col-day-flex"
                :class="{
                  'odd-bk': index0 % 2 !== 0,
                  'even-bk': index0 % 2 === 0,
                }"
              >
                <div class="hours-col">
                  <template
                    v-for="(item, index) in getDayOfWeekTimes(item0.dayOfWeek)
                      .times"
                  >
                    <h4
                      :key="index + '_hours'"
                      :style="{
                        marginBottom: 'calc(100px - ' + index / 13 + 'px)',
                      }"
                    >
                      {{
                        item.i.split(":")[0] +
                        ":" +
                        getCalendarMinute(item.i.split(":")[1])
                      }}
                    </h4>
                  </template>
                </div>
                <template v-for="(item, index) in emps">
                  <div :key="index" class="col-emp">
                    <column
                      @details="details"
                      @multiDetails="multiDetails"
                      :shop="Number.parseInt(selectedShop)"
                      @appendCard="appendCard"
                      @siteAlert="siteAlert"
                      @siteAlertSuccess="siteAlertSuccess"
                      @addNew="addNew"
                      :na="item.na"
                      card
                      :emp="item.employees"
                      :isClosedDay="item0.isClosed"
                      :full-date="item0.day"
                      :day="item0.day.split('T')[0].split('-')[2]"
                      @move="move"
                      @refreshEmp="getEmpArray"
                      :colorIndex="index"
                      :cells="
                        getDayOfWeekTimes(
                          item0.dayOfWeek,
                          item.employees.idEmployee
                        )
                      "
                      :dow="item0.dayOfWeek"
                    ></column>
                  </div>
                </template>
              </div>
            </div>
          </template>
        </div>

        <!-- Notification tray for new/cancelled reservations -->
        <div class="res-notify-tray">
          <transition-group name="res-notify-fade" tag="div">
            <div
              v-for="(notif, idx) in resNotificationsNew"
              :key="'new-' + idx"
              class="res-notify-card res-notify-new"
            >
              <div class="res-notify-header">
                <v-icon small class="res-notify-icon">event_available</v-icon>
                <span class="res-notify-title">{{ getString("Nuove prenotazioni!") }}</span>
                <v-btn icon small flat class="res-notify-close" @click="resNotificationsNew.splice(idx, 1)">
                  <v-icon small>close</v-icon>
                </v-btn>
              </div>
              <div style="max-height: 350px; overflow-y: auto;">
                <div
                  v-for="(item, i) in notif.items"
                  :key="i"
                  class="res-notify-item"
                  @click="goToReservation(item); notif.items.splice(i, 1)"
                >
                  <v-icon small class="res-notify-item-icon">person</v-icon>
                  <span class="res-notify-name">{{ item.uName }} {{ item.uSurname }}</span>
                  <span class="res-notify-date">{{ formatNotifyDate(item.dateAndTime) }}</span>
                </div>
              </div>
            </div>
            <div
              v-for="(notif, idx) in resNotificationsDel"
              :key="'del-' + idx"
              class="res-notify-card res-notify-del"
            >
              <div class="res-notify-header">
                <v-icon small class="res-notify-icon">event_busy</v-icon>
                <span class="res-notify-title">{{ getString("Prenotazioni annullate") }}</span>
                <v-btn icon small flat class="res-notify-close" @click="resNotificationsDel.splice(idx, 1)">
                  <v-icon small>close</v-icon>
                </v-btn>
              </div>
              <div style="max-height: 350px; overflow-y: auto;">
                <div
                  v-for="(item, i) in notif.items"
                  :key="i"
                  class="res-notify-item"
                  @click="goToReservation(item); notif.items.splice(i, 1)"
                >
                  <v-icon small class="res-notify-item-icon">person_outline</v-icon>
                  <span class="res-notify-name">{{ item.uName }} {{ item.uSurname }}</span>
                  <span class="res-notify-date">{{ formatNotifyDate(item.dateAndTime) }}</span>
                </div>
              </div>
            </div>
          </transition-group>
        </div>

        <v-snackbar
          v-show="!mainLoad"
          v-model="bar"
          bottom
          :timeout="0"
          color="grey darken-2"
          :class="{ bar: isFullscreen }"
        >
          <v-tooltip top>
            <v-btn
              class="q-text-whitesmoke"
              slot="activator"
              flat
              @click="dateChoose = true"
            >
              <v-icon x-large>today</v-icon>
            </v-btn>
            <span>{{ getString("Scegli il giorno da cui partire") }}</span>
          </v-tooltip>
          <v-tooltip v-if="this.showFullButtons" top>
            <v-btn
              class="q-text-whitesmoke"
              slot="activator"
              :disabled="isFullscreen"
              flat
              @click="toogleFullscreen"
            >
              <v-icon x-large>fullscreen</v-icon>
            </v-btn>
            <span>{{ getString("Modalità schermo intero") }}</span>
          </v-tooltip>
          <v-tooltip v-if="this.showFullButtons" top>
            <v-btn
              class="q-text-whitesmoke"
              slot="activator"
              :disabled="!isFullscreen"
              flat
              @click="toogleFullscreen"
            >
              <v-icon x-large>fullscreen_exit</v-icon>
            </v-btn>
            <span>{{ getString("Esci da schermo intero") }}</span>
          </v-tooltip>
          <v-tooltip top>
            <v-btn
              @touchEnd="initAudio"
              class="q-text-whitesmoke"
              slot="activator"
              flat
              @click="alertSuccess = false"
            >
              <v-icon x-large>volume_up</v-icon>
            </v-btn>
            <span>{{ getString("Attiva audio su ipad o smartphone") }}</span>
          </v-tooltip>
        </v-snackbar>

        <modal
          v-show="detailsDialog"
          @click="detailsDialog = false"
          width="800"
        >
          <v-card-title class="no-padding" slot="header">
            <v-toolbar color="orange darken-2" style="text-align: center">
              <span class="headline q-text-whitesmoke text-center">{{
                getString("Dettagli prenotazione")
              }}</span>
            </v-toolbar>
          </v-card-title>
          <v-card-text slot="body" style="position: relative">
            <v-layout wrap class="box-container mb-2">
              <v-flex xs12 class="center">
                <h1>
                  <b>{{ detCard.fullName }}</b>
                </h1>
              </v-flex>
              <v-flex
                style="padding-right: 10px; align-self: center"
                shrink
                lg5
              >
                <img
                  :src="defaultAvatar(detCard.selectedCard)"
                  onerror="this.src='/../../../static/img/default-avatar.png';"
                  ref="avatar"
                  class="avatar-img elevation-3"
                />
              </v-flex>
              <v-flex xs12 sm6 md6 lg7>
                <v-layout wrap fill-height>
                  <v-flex xs12 md12 style="text-align: start">
                    <v-layout column>
                      <!-- Riga 1 -->
                      <v-layout row align-center class="mb-0">
                        <v-flex shrink class="mr-2">
                          <v-icon>calendar_month</v-icon>
                        </v-flex>
                        <v-flex>
                          <h2 class="mb-0">
                            {{ getItalianDate(detCard.getDate) }}
                          </h2>
                        </v-flex>
                      </v-layout>

                      <!-- Riga 2 -->
                      <v-layout row align-center class="mb-0">
                        <v-flex shrink class="mr-2">
                          <v-icon>schedule</v-icon>
                        </v-flex>
                        <v-flex>
                          <h2 class="mb-0">{{ detCard.selectedTime }}</h2>
                        </v-flex>
                      </v-layout>

                      <!-- Riga 3 -->
                      <v-layout row align-center>
                        <v-flex shrink class="mr-2">
                          <v-icon>person</v-icon>
                        </v-flex>
                        <v-flex>
                          <div>
                            Con: {{ detCard.selectedCard.nameEmployee }}
                          </div>
                        </v-flex>
                      </v-layout>
                    </v-layout>
                  </v-flex>
                  <v-flex xs12 md12>
                    <!-- <h2>{{ getString("Cosa deve fare") }}</h2> -->
                    <hr class="my-2" />

                    <template v-for="(item, index) in selectedService">
                      <div :key="index" class="d-flex">
                        <div class="flex-grow-1">
                          {{ item.description }}
                        </div>
                        <div style="text-align: end">
                          {{ item.price }}
                        </div>
                      </div>
                    </template>
                    <hr class="my-2" />
                    <div
                      :key="index"
                      class="d-flex"
                      v-if="selectedService.length > 1"
                    >
                      <div style="text-align: end">
                        <b>
                          Totale:
                          {{
                            selectedService.reduce(
                              (sum, service) => {
                                if (service.price === "nd") return sum;
                                const price = parseFloat(service.price.replace("€", "").trim());
                                return sum + (isNaN(price) ? 0 : price);
                              },
                              0
                            )
                          }}€</b
                        >
                      </div>
                    </div>
                  </v-flex>
                   <v-flex xs12 md12>
                    <div class="align-center">
                      <v-icon class="mr-1">email</v-icon>
                      {{ detCard.getEmail }}
                    </div>

                    <div class="align-center">
                      <v-icon class="mr-1">phone</v-icon>
                      {{ detCard.getPhone }}
                    </div>
                  </v-flex>
                  <v-flex xs12 md12>
                    <v-btn flat small class="q-orange-bk q-text-whitesmoke"
                      v-if="detCard.selectedCard.referenceUsers > 0 || detCard.selectedCard.referenceCrmClient > 0"
                      @click="openClientCard(detCard.selectedCard)">
                      <v-icon small left>person</v-icon>
                      {{ getString("Scheda cliente") }}
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
            <v-layout wrap>
              <v-flex xs12 v-if="showWarningSeriesRes(detCard.selectedCard)">
                <p class="q-orange-bk q-text-whitesmoke warning-message">
                  Attenzione: questa è una prenotazione ripetuta che terminerà
                  il
                  {{
                    getFormattedDate(detCard.selectedCard.lastReservationDate)
                  }}
                </p>
              </v-flex>
              <v-flex xs12 v-if="detCard.selectedCard.isLastOne">
                <p class="q-orange-bk q-text-whitesmoke warning-message">
                  Attenzione: questa è l'ultima prenotazione di una serie.
                </p>
              </v-flex>
              <v-flex grow>
                <h2>{{ getString("Nota prenotazione") }}</h2>
                <div style="position: relative">
                  <div v-show="isLoading" class="overlay">
                    <v-progress-circular indeterminate> </v-progress-circular>
                  </div>
                  <div>
                    <v-textarea
                      class="mr-2"
                      solo
                      v-bind:label="getString('Nota della prenotazione')"
                      @blur="saveNote"
                      v-model="newNote"
                    ></v-textarea>
                  </div>
                </div>
              </v-flex>
              <v-flex xs12 v-if="detCard.selectedCard.referenceUsers > 0">
                 <!-- Note (full width, in basso) -->
            <v-divider class="my-4"></v-divider>
            <div style="display:flex; align-items:center; margin-bottom:6px">
              <div class="section-title" style="margin:0; flex:1">
                <v-icon small class="mr-1" color="blue-grey">notes</v-icon>
                {{ getString("Note cliente") }}
              </div>
              <v-btn icon small flat @click="addNoteDialog = true" style="margin:0" :title="getString('Aggiungi nota')"><v-icon color="red lighten-2">add_circle_outline</v-icon></v-btn>
            </div>
               
                <div style="max-height: 260px; overflow-y: auto; margin-bottom: 8px">
                  <div v-if="globalNotes.length === 0" style="color: #aaa; font-size: 13px; padding: 8px 0">{{ getString("Nessuna nota") }}</div>
                  <v-card v-for="n in globalNotes" :key="n.idNote" class="mb-1 elevation-0" style="border-left: 3px solid #d5725b; padding: 6px 10px">
                    <div style="display:flex; justify-content:space-between; align-items:flex-start">
                      <div>
                        <div style="font-size:12px; color:#888; margin-bottom:2px">{{ formatNoteDate(n.createdDate) }}<span v-if="n.author" style="margin-left:6px; font-style:italic">— {{ n.author }}</span></div>
                        <div style="font-size:14px; white-space: pre-wrap">{{ n.note }}</div>
                      </div>
                      <!-- <v-btn icon small flat @click="pendingDeleteNoteId = n.idNote; confirmDeleteNoteDialog = true" style="margin:0"><v-icon small color="red lighten-2">delete</v-icon></v-btn> -->
                    </div>
                  </v-card>
                </div>
                
              </v-flex>
             
            </v-layout>
            <v-layout wrap align-center>
              <v-flex xs12 sm12 class="center">
                <v-tooltip top>
                  <v-btn
                    slot="activator"
                    class="orange darken-3 q-text-whitesmoke btn-operation"
                    @click.native="
                      showWarningSeriesRes(detCard.selectedCard)
                        ? (confirmDeletePc = true) //Cambiato da quando abbiamo implementato le prenotazioni ripetutute anche agli utenti app
                        : (confirmDelete = true)
                    "
                    >Annulla<v-icon dark right>delete</v-icon>
                  </v-btn>
                  <span>{{ getString(`Annulla la prenotazione`) }}</span>
                </v-tooltip>

                <v-tooltip v-if="detCard.selectedCard.referenceUsers > 0" top>
                  <v-btn
                    @click="confirmBan = true"
                    slot="activator"
                    class="orange darken-3 q-text-whitesmoke btn-operation"
                    color="red"
                    >Blocca <v-icon dark right>not_interested</v-icon>
                  </v-btn>
                  <span>{{
                    getString(
                      `Blocca l'utente e annulla tutte le sue prenotazioni`
                    )
                  }}</span>
                </v-tooltip>
              </v-flex>
            </v-layout>
            <v-layout wrap align-center>
              <!-- <v-flex
                xs4
                sm3
                v-if="
                  detCard.selectedCard.referenceUsers > 0 ||
                  detCard.selectedCard.phone
                "
              >
                <span>Comunicazioni:</span>
              </v-flex> -->
              <v-flex xs12 sm12 class="center">
                <v-tooltip v-if="detCard.selectedCard.referenceUsers > 0" top>
                  <v-btn
                    @click="openNotificationDialog"
                    slot="activator"
                    class="orange darken-3 q-text-whitesmoke btn-operation"
                    color="green"
                    >Notifica<v-icon dark right>campaign</v-icon>
                  </v-btn>
                  <span>{{ getString(`Invia una notifica all'utente`) }}</span>
                </v-tooltip>

                <v-tooltip v-if="detCard.selectedCard.phone" top>
                  <v-btn
                    @click="openWhatsapp"
                    slot="activator"
                    class="orange darken-3 q-text-whitesmoke btn-operation"
                    color="green"
                    >Whatsapp<v-icon dark right>campaign</v-icon>
                  </v-btn>
                  <span>{{
                    getString(`Invia un messaggio whatsapp all'utente`)
                  }}</span>
                </v-tooltip>
              </v-flex>
            </v-layout>
            <v-layout wrap align-center>
              <!-- <v-flex xs4 sm3 v-if="detCard.selectedCard.referenceUsers > 0">
                <span>Utilità:</span>
              </v-flex> -->
              <v-flex xs12 sm12 class="center">
                <v-tooltip v-if="detCard.selectedCard.referenceUsers > 0" top>
                  <v-btn
                    slot="activator"
                    :disabled="!hasFidelityDlc"
                    class="orange darken-3 q-text-whitesmoke btn-operation"
                    @click="() => (fidelityPointDialog = true)"
                    >{{ getString("Fidelity") }}
                    <v-icon dark right>redeem</v-icon>
                  </v-btn>
                  <span>{{
                    hasFidelityDlc
                      ? getString(`Assegna punti all'utente`)
                      : getString(`Acquista il modulo Fidelity card`)
                  }}</span>
                </v-tooltip>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions slot="footer">
            <v-spacer></v-spacer>
            <v-btn
              class="q-orange q-whitesmoke-bk bold"
              @click.native="detailsDialog = false"
              >{{ getString("Chiudi") }}</v-btn
            >
          </v-card-actions>
        </modal>
        <modal
          v-show="fidelityPointDialog"
          @click="fidelityPointDialog = false"
        >
          <v-card-title class="no-padding" slot="header">
            <v-toolbar color="orange darken-2" style="text-align: center">
              <span class="headline q-text-whitesmoke text-center">{{
                getString("Associa punti carta fedeltà")
              }}</span>
            </v-toolbar>
          </v-card-title>
          <v-card-text slot="body" style="position: relative">
            <v-layout wrap style="text-align: center">
              <v-flex xs4>
                <v-btn class="box-container" @click="() => (selectedPoint = 10)"
                  >10</v-btn
                >
              </v-flex>
              <v-flex xs4>
                <v-btn class="box-container" @click="() => (selectedPoint = 20)"
                  >20</v-btn
                >
              </v-flex>
              <v-flex xs4>
                <v-btn class="box-container" @click="() => (selectedPoint = 30)"
                  >30</v-btn
                >
              </v-flex>
              <v-flex xs4>
                <v-btn class="box-container" @click="() => (selectedPoint = 40)"
                  >40</v-btn
                >
              </v-flex>
              <v-flex xs4>
                <v-btn class="box-container" @click="() => (selectedPoint = 50)"
                  >50</v-btn
                >
              </v-flex>
              <v-flex xs4>
                <v-btn class="box-container" @click="() => (selectedPoint = 60)"
                  >60</v-btn
                >
              </v-flex>
              <v-flex xs4></v-flex>
              <v-flex xs4>
                <v-layout>
                  <v-text-field
                    solo
                    color="orange"
                    v-bind:label="getString('Punti')"
                    v-model="selectedPoint"
                  />
                </v-layout>
                <v-btn
                  class="orange darken-3 q-text-whitesmoke"
                  @click="updateScore"
                  >{{ getString("Conferma") }}
                  <v-icon dark right>redeem</v-icon>
                </v-btn>
              </v-flex>
              <v-flex xs4></v-flex>
            </v-layout>
          </v-card-text>
        </modal>
        <modal v-show="moveInfo" @click="moveInfo = false">
          <v-card-title class="no-padding" slot="header">
            <v-toolbar color="red lighten-2" style="text-align: center">
              <span
                class="headline q-text-whitesmoke text-center"
                v-html="moveText"
              ></span>
            </v-toolbar>
          </v-card-title>
          <v-card-text slot="body">
            <v-layout wrap>
              <v-flex xs12>
                <h4 style="text-align: center; width: 100%">
                  {{ getString("Scegli a che giorno spostare") }}
                </h4>
                <v-date-picker
                  no-title
                  class="kill"
                  header-color="white"
                  :locale="locale"
                  :title-date-format="formatTitle"
                  show-current
                  color="red lighten-2"
                  ref="picker"
                  v-model="moveDate"
                  full-width
                ></v-date-picker>
              </v-flex>
              <v-flex xs6 md6>
                <v-select
                  solo
                  v-model="moveHour"
                  :items="hoursTotal"
                  style="margin-top: 10px"
                  :label="getString('Ora')"
                  :menu-props="{ bottom: true, offsetY: true }"
                ></v-select>
              </v-flex>
              <v-flex xs6 md6>
                <v-select
                  solo
                  v-model="moveMin"
                  :items="minutesTotal"
                  style="margin-left: 10px; margin-top: 10px"
                  :label="getString('Minuti')"
                  :menu-props="{ bottom: true, offsetY: true }"
                ></v-select>
              </v-flex>
              <v-flex xs12>
                <v-select
                  item-text="description"
                  item-value="idPrice"
                  v-model="moveServices"
                  :items="services"
                  return-object
                  label="Seleziona il servizio"
                  :menu-props="{ bottom: true, offsetY: true }"
                  multiple
                  solo
                  chips
                ></v-select>
              </v-flex>
              <v-flex xs12>
                <v-select
                  solo
                  :items="emps"
                  v-model="moveEmp"
                  item-text="employees.name"
                  item-value="employees.idEmployee"
                  :label="getString('Dipendente')"
                  :menu-props="{ bottom: true, offsetY: true }"
                ></v-select>
              </v-flex>
              <v-flex
                xs12
                v-if="isCardRealUser"
                class="centered-input elevation-2"
                :style="{
                  background: isDarkMode ? 'var(--background-form)' : 'white',
                  borderRadius: '10px',
                  padding: '5px',
                }"
              >
                <v-checkbox
                  v-model="notifyUser"
                  color="#d5725b"
                  :label="getString('Vuoi notificare l\'utente? ')"
                ></v-checkbox>
              </v-flex>
            </v-layout>
            <v-progress-linear
              indeterminate
              v-show="isLoading"
              :active="isLoading"
              :height="2"
            ></v-progress-linear>
          </v-card-text>
          <v-card-actions slot="footer">
            <v-layout style="justify-content: end; padding: 10px">
              <v-btn
                class="q-orange q-whitesmoke-bk bold"
                :disabled="isLoading"
                @click.native="deselectOnly"
                >{{ getString("Chiudi") }}</v-btn
              >

              <v-btn
                class="q-orange-bk q-text-whitesmoke bold"
                :disabled="isLoading"
                @click.native="moveReservation"
                >{{ getString("Sposta") }}</v-btn
              >
            </v-layout>
          </v-card-actions>
        </modal>
        <modal v-show="dateChoose" @click="dateChoose = false">
          <v-card-title class="no-padding" slot="header">
            <v-toolbar color="red lighten-2" style="text-align: center">
              <span class="headline q-text-whitesmoke text-center">{{
                getString("Cambia data")
              }}</span>
            </v-toolbar>
          </v-card-title>
          <v-card-text slot="body">
            <v-layout wrap>
              <p>
                {{
                  getString("Scegli da che giorno deve partire il calendario")
                }}
              </p>
              <v-date-picker
                no-title
                class="kill"
                header-color="white"
                :locale="locale"
                @change="changeDate"
                :title-date-format="formatTitle"
                show-current
                color="red lighten-2"
                ref="picker"
                v-model="startDate"
                full-width
              ></v-date-picker>
            </v-layout>
            <v-progress-linear
              indeterminate
              v-show="isLoading"
              :active="isLoading"
              :height="2"
            ></v-progress-linear>
          </v-card-text>
          <v-card-actions slot="footer">
            <v-btn
              class="q-orange q-whitesmoke-bk bold"
              :disabled="isLoading"
              @click.native="dateChoose = false"
              >{{ getString("Chiudi") }}</v-btn
            >
          </v-card-actions>
        </modal>

        <!-- Popup prenotazioni collise -->
        <modal v-show="multiDetailsDialog" @click="multiDetailsDialog = false" width="760">
          <v-card-title class="no-padding" slot="header">
            <v-toolbar color="orange darken-2" style="text-align: center">
              <span class="headline q-text-whitesmoke text-center multi-res-toolbar-title">
                {{ getString("Prenotazioni collise") }}
                <v-chip small color="white" text-color="orange darken-2" style="margin-left:8px">{{ multiDetailCards.length }}</v-chip>
              </span>
            </v-toolbar>
          </v-card-title>
          <v-card-text slot="body" class="multi-res-body">
            <div class="multi-res-intro">
              <div>
                <div class="multi-res-intro-title">{{ getString("Stesso orario, più richieste") }}</div>
                <div class="multi-res-intro-subtitle">
                  {{ getString("Le prenotazioni sono raggruppate per servizio: scegli il gruppo e poi apri il dettaglio del cliente.") }}
                </div>
              </div>
              <div class="multi-res-stats">
                <div class="multi-res-stat-card">
                  <div class="multi-res-stat-number">{{ multiDetailGroups.length }}</div>
                  <div class="multi-res-stat-label">{{ getString("Servizi") }}</div>
                </div>
                <div class="multi-res-stat-card">
                  <div class="multi-res-stat-number">{{ multiDetailCards.length }}</div>
                  <div class="multi-res-stat-label">{{ getString("Clienti") }}</div>
                </div>
              </div>
            </div>

            <div
              v-for="group in multiDetailGroups"
              :key="group.service"
              class="multi-res-group"
            >
              <div class="multi-res-group-header">
                <div>
                  <div class="multi-res-group-title">{{ group.service }}</div>
                  <div class="multi-res-group-subtitle">
                    {{ group.items.length }} {{ group.items.length === 1 ? getString("iscritto") : getString("iscritti") }}
                  </div>
                </div>
                <v-chip small color="orange lighten-4" text-color="orange darken-3">
                  <v-icon x-small left>groups</v-icon>{{ group.items.length }}
                </v-chip>
              </div>

              <div
                v-for="item in group.items"
                :key="group.service + '-' + item.card.idReservation"
                @click="openFromMulti(item.originalIndex)"
                class="multi-res-row"
              >
                <div class="multi-res-avatar-wrap">
                  <img
                    :src="defaultAvatar(item.card)"
                    onerror="this.src='/../../../static/img/default-avatar.png';"
                    class="multi-res-avatar"
                  />
                </div>
                <div class="multi-res-main">
                  <div class="multi-res-name-row">
                    <span class="multi-res-name">{{ getMultiCardName(item.card) }}</span>
                    <v-chip
                      x-small
                      :color="item.card.referenceUsers > 0 ? 'green lighten-4' : 'blue-grey lighten-4'"
                      :text-color="item.card.referenceUsers > 0 ? 'green darken-3' : 'blue-grey darken-2'"
                    >
                      {{ item.card.referenceUsers > 0 ? 'Registrato da App' : item.card.referenceCrmClient > 0 ? 'Registrato da CRM' : 'Manuale' }}
                    </v-chip>
                  </div>
                  <div class="multi-res-meta-row">
                    <span class="multi-res-time">{{ getMultiCardTime(item.card) }}</span>
                    <span class="multi-res-dot"></span>
                    <span class="multi-res-phone">{{ item.card.phone || item.card.flyPhone || getString('Telefono non disponibile') }}</span>
                  </div>
                </div>
                <div class="multi-res-action">
                  <v-icon color="orange darken-2">chevron_right</v-icon>
                </div>
              </div>
            </div>
          </v-card-text>
          <v-card-actions slot="footer">
            <v-spacer></v-spacer>
            <v-btn class="q-orange q-whitesmoke-bk bold" @click.native="multiDetailsDialog = false">
              {{ getString("Chiudi") }}
            </v-btn>
          </v-card-actions>
        </modal>

        <modal v-show="confirmDelete" @click="confirmDelete = false">
          <v-card-title class="no-padding" slot="header">
            <v-toolbar color="red darken-2" style="text-align: center">
              <span class="headline q-text-whitesmoke text-center">{{
                getString("Conferma annullamento")
              }}</span>
            </v-toolbar>
          </v-card-title>
          <v-card-text slot="body">
            <v-layout wrap>
              <p>
                {{
                  getString(
                    "La cancellazione della prenotazione è un'azione irreversibile. Confermi?"
                  )
                }}
              </p>
            </v-layout>
            <v-progress-linear
              indeterminate
              v-show="isLoading"
              :active="isLoading"
              :height="2"
            ></v-progress-linear>
          </v-card-text>
          <v-card-actions slot="footer">
            <v-btn
              class="q-orange"
              flat
              :disabled="isLoading"
              @click.native="confirmDelete = false"
              >{{ getString("No") }}</v-btn
            >
            <v-spacer></v-spacer>
            <v-btn
              flat
              class="q-orange-bk q-text-whitesmoke"
              :disabled="isLoading"
              @click.native="deleteReservation"
              >{{ getString("Conferma") }}</v-btn
            >
          </v-card-actions>
        </modal>
        <modal v-show="confirmDeletePc" @click="confirmDeletePc = false">
          <v-card-title class="no-padding" slot="header">
            <v-toolbar color="red darken-2" style="text-align: center">
              <span class="headline q-text-whitesmoke text-center">{{
                getString("Conferma annullamento")
              }}</span>
            </v-toolbar>
          </v-card-title>
          <v-card-text slot="body">
            <v-layout wrap>
              <p>
                {{
                  getString(
                    "La cancellazione della prenotazione è un'azione irreversibile. Vuoi cancellare solo questa prenotazione o anche tutte le seguenti?"
                  )
                }}
              </p>
            </v-layout>
            <v-progress-linear
              indeterminate
              v-show="isLoading"
              :active="isLoading"
              :height="2"
            ></v-progress-linear>
          </v-card-text>
          <v-card-actions slot="footer">
            <v-btn
              class="q-orange"
              flat
              :disabled="isLoading"
              @click.native="confirmDeletePc = false"
              >{{ getString("Annulla") }}</v-btn
            >
            <v-spacer></v-spacer>
            <v-btn
              flat
              class="q-orange-bk q-text-whitesmoke"
              :disabled="isLoading"
              @click.native="deleteReservation"
              >{{ getString("Solo questa") }}</v-btn
            >
            <v-btn
              flat
              class="q-orange-bk q-text-whitesmoke"
              :disabled="isLoading"
              @click.native="deleteReservationAll"
              >{{ getString("Questa e tutte le seguenti") }}</v-btn
            >
          </v-card-actions>
        </modal>
        <modal v-show="confirmBan" @click="confirmDelete = false">
          <v-card-title class="no-padding" slot="header">
            <v-toolbar color="red darken-2" style="text-align: center">
              <span class="headline q-text-whitesmoke text-center">{{
                getString("Conferma blocco")
              }}</span>
            </v-toolbar>
          </v-card-title>
          <v-card-text slot="body">
            <v-layout wrap>
              <p>
                {{
                  getString(
                    "Bloccando l'utente, egli non sarà più in grado di effettuare alcuna prenotazione e tutte le sue successive verranno annullate. Potrai comunque rimuovere lo stato di blocco dalla tab clienti delle impostazioni del negozio. Confermi?"
                  )
                }}
              </p>
            </v-layout>
            <v-progress-linear
              indeterminate
              v-show="isLoading"
              :active="isLoading"
              :height="2"
            ></v-progress-linear>
          </v-card-text>
          <v-card-actions slot="footer">
            <v-btn
              class="q-orange"
              flat
              @click.native="confirmBan = false"
              :disabled="isLoading"
              >{{ getString("No") }}</v-btn
            >
            <v-spacer></v-spacer>
            <v-btn
              flat
              class="q-orange-bk q-text-whitesmoke"
              :disabled="isLoading"
              @click.native="banUser"
              >{{ getString("Conferma") }}</v-btn
            >
          </v-card-actions>
        </modal>
        <modal v-show="sendNotificationPopup">
          <v-card-title class="no-padding" slot="header">
            <v-toolbar color="red lighten-1" style="text-align: center">
              <span class="headline q-text-whitesmoke text-center">{{
                getString("Invia una notifica")
              }}</span>
            </v-toolbar>
          </v-card-title>
          <v-card-text slot="body">
            <v-layout wrap>
              <v-flex xs12>
                <!-- <v-flex xs12>
                <v-text-field
                  solo
                  v-bind:label="getString('Titolo')"
                  v-model="newNotificationBody.title"
                />
              </v-flex>
              <div
                :class="{
                  counter: true,
                  'counter-red': newNotificationBody.title.length > 50,
                }"
              >
                <h5>{{ countCharTitle }}/50</h5>
              </div> -->
                <v-textarea
                  solo
                  v-bind:label="getString('Messaggio')"
                  v-model="newNotificationBody.message"
                ></v-textarea>
                <div
                  :class="{
                    counter: true,
                    'counter-red': newNotificationBody.message.length > 300,
                  }"
                >
                  <h5>{{ countChar }}/300</h5>
                </div>
              </v-flex>
            </v-layout>
            <v-progress-linear
              indeterminate
              v-show="isLoading"
              :active="isLoading"
              :height="2"
            ></v-progress-linear>
          </v-card-text>
          <v-card-actions slot="footer">
            <v-btn
              class="q-orange"
              flat
              @click.native="() => (sendNotificationPopup = false)"
              >{{ getString("Annulla") }}</v-btn
            >
            <v-spacer></v-spacer>
            <v-btn
              class="q-orange-bk q-text-whitesmoke"
              :disabled="isLoading"
              flat
              @click="sendNotification"
              >{{ getString("Invia") }}</v-btn
            >
          </v-card-actions>
        </modal>

        <modal v-show="openWaitingList" width="800">
          <v-card-title class="no-padding" slot="header">
            <v-toolbar color="red lighten-2" style="text-align: center">
              <span class="headline q-text-whitesmoke text-center">{{
                getString(`Clienti in attesa`)
              }}</span>
            </v-toolbar>
          </v-card-title>
          <v-card-text slot="body">
            <v-layout wrap>
              <span style="padding: 10px"
                >Lista di tutti i clienti in cerca di un posto. Verranno
                notificati in caso di posto libero, o puoi contattarli per
                fissare un altro appuntamento.</span
              >
              <v-flex xs12>
                <v-data-table
                  :headers="[
                    { text: 'Data', value: 'day' },
                    { text: 'Nome', value: 'name' },
                    { text: 'Cognome', value: 'surname' },
                    { text: 'Collaboratore', value: 'employeeName' },
                    { text: 'Nota', value: 'nota' },
                    { text: 'Creata il', value: 'created' },
                  ]"
                  :items="waitingList"
                  :items-per-page="10"
                  :rows-per-page-text="getString('Date per pagina')"
                  :no-data-text="getString('Dati non disponibili')"
                  item-key="name"
                  class="elevation-1"
                >
                  <template slot="items" slot-scope="props">
                    <tr
                      style="cursor: pointer"
                      @click="
                        () => {
                          addNewDialogWaitingList = props.item;
                        }
                      "
                    >
                      <td>{{ getFormattedDate(props.item.day) }}</td>
                      <td>{{ props.item.name }}</td>
                      <td>{{ props.item.surname }}</td>
                      <td>{{ props.item.employeeName }}</td>
                      <td>
                        <v-tooltip top>
                          <div slot="activator">
                            {{
                              props.item.nota && props.item.nota.length > 25
                                ? `${props.item.nota.substring(0, 25)}...`
                                : props.item.nota
                            }}
                          </div>
                          {{ props.item.nota }}
                        </v-tooltip>
                      </td>
                      <td>{{ getFormattedDateTime(props.item.created) }}</td>
                    </tr>
                  </template>
                </v-data-table>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions slot="footer">
            <v-btn
              class="q-orange q-whitesmoke-bk bold"
              @click.native="
                () => {
                  openWaitingList = false;
                }
              "
              >{{ getString("Chiudi") }}</v-btn
            >
          </v-card-actions>
        </modal>

        <modal v-show="openSearchUser" width="800">
          <v-card-title class="no-padding" slot="header">
            <v-toolbar color="blue" style="text-align: center">
              <span class="headline q-text-whitesmoke text-center">{{
                getString(`Cerca cliente`)
              }}</span>
            </v-toolbar>
          </v-card-title>
          <v-card-text slot="body">
            <v-layout wrap>
              <v-flex xs6 md5>
                <v-text-field
                  type="text"
                  class="t-field"
                  v-model="searchUserName"
                  :label="getString('Nome')"
                  solo
                  color="red lighten-3"
                />
              </v-flex>
              <v-flex xs6 md5>
                <v-text-field
                  type="text"
                  class="t-field"
                  v-model="searchUserSurname"
                  :label="getString('Cognome')"
                  solo
                  color="red lighten-3"
                />
              </v-flex>
              <v-flex xs12 md2>
                <v-btn class="q-orange q-whitesmoke-bk bold" @click="searchUser"
                  >Cerca</v-btn
                >
              </v-flex>
              <v-flex xs12>
                <v-data-table
                  :headers="[
                    { text: 'Nome', value: 'name' },
                    { text: 'Cognome', value: 'surname' },
                    { text: 'Scheda cliente', value: '' },
                  ]"
                  :items="usersAll"
                  :items-per-page="10"
                  :loading="loadTable"
                  item-key="uniqueID"
                  :rows-per-page-text="getString('Date per pagina')"
                  :no-data-text="getString('Dati non disponibili')"
                  class="elevation-1"
                >
                  <!-- Slot per il loader -->
                  <template v-slot:progress>
                    <v-progress-linear
                      indeterminate
                      color="primary"
                    ></v-progress-linear>
                  </template>
                  <template slot="items" slot-scope="props">
                    <tr>
                      <td>
                        {{ props.item.name }}
                      </td>
                      <td>
                        {{ props.item.surname }}
                      </td>
                      <td>
                        <v-btn
                          icon
                          class="q-orange-bk q-text-whitesmoke"
                          @click="openSchedaUtente(props.item)"
                        >
                          <v-icon>schedule_send</v-icon>
                        </v-btn>
                      </td>
                    </tr>
                  </template>
                </v-data-table>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions slot="footer">
            <v-btn
              class="q-orange q-whitesmoke-bk bold"
              @click.native="
                () => {
                  openSearchUser = false;
                }
              "
              >{{ getString("Chiudi") }}</v-btn
            >
          </v-card-actions>
        </modal>

        <modal v-show="openSchedaUser" width="800">
          <v-card-title class="no-padding" slot="header">
            <v-toolbar color="blue" style="text-align: center">
              <span class="headline q-text-whitesmoke text-center">{{
                getString(`Prenotazioni del cliente`)
              }}</span>
            </v-toolbar>
          </v-card-title>
          <v-card-text slot="body">
            <v-layout wrap>
              <v-flex xs12>
                <v-data-table
                  :headers="[
                    { text: 'Data', value: 'dateAndTime' },
                    { text: 'Nome', value: 'flyName' },
                    { text: 'Cognome', value: 'flySurname' },
                    { text: 'Servizi', value: 'service' },
                    { text: 'Vai a', value: '' },
                  ]"
                  :items="reservationUserList"
                  :items-per-page="10"
                  :loading="loadTable2"
                  item-key="idReservation"
                  :rows-per-page-text="getString('Date per pagina')"
                  :no-data-text="getString('Dati non disponibili')"
                  class="elevation-1"
                >
                  <!-- Slot per il loader -->
                  <template v-slot:progress>
                    <v-progress-linear
                      indeterminate
                      color="primary"
                    ></v-progress-linear>
                  </template>
                  <template slot="items" slot-scope="props">
                    <tr>
                      <td>
                        {{ getFormattedDateTime(props.item.dateAndTime) }}
                      </td>
                      <td>
                        {{
                          props.item.uName
                            ? props.item.uName
                            : props.item.flyName
                        }}
                      </td>
                      <td>
                        {{
                          props.item.uSurname
                            ? props.item.uSurname
                            : props.item.flySurname
                        }}
                      </td>
                      <td>{{ props.item.service }}</td>
                      <td>
                        <v-btn
                          icon
                          class="q-orange-bk q-text-whitesmoke"
                          @click="goToReservation(props.item)"
                        >
                          <v-icon>schedule_send</v-icon>
                        </v-btn>
                      </td>
                    </tr>
                  </template>
                </v-data-table>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions slot="footer">
            <v-btn
              class="q-orange q-whitesmoke-bk bold"
              @click.native="
                () => {
                  openSchedaUser = false;
                }
              "
              >{{ getString("Chiudi") }}</v-btn
            >
          </v-card-actions>
        </modal>
        <modal v-show="openSettingsModel" width="1200">
          <v-card-title class="no-padding" slot="header">
            <v-toolbar color="grey" style="text-align: center">
              <span class="headline q-text-whitesmoke text-center">{{
                getString(`Impostazioni calendario`)
              }}</span>
            </v-toolbar>
          </v-card-title>
          <v-card-text slot="body">
            <label><b>Gestione card</b></label>
            <v-switch
              color="red lighten-3"
              :label="
                getString('Il colore delle card dipenderà dal servizio scelto')
              "
              v-model="serviceColor"
            ></v-switch>
          </v-card-text>
          <v-card-actions slot="footer">
            <v-btn
              class="q-orange q-whitesmoke-bk bold"
              @click.native="closeSettingsModal"
              >{{ getString("Chiudi") }}</v-btn
            >
          </v-card-actions>
        </modal>
        <modal v-show="openNotificationRead" width="1200">
          <v-card-title class="no-padding" slot="header">
            <v-toolbar color="orange" style="text-align: center">
              <span class="headline q-text-whitesmoke text-center">{{
                getString(`Notifiche inviate`)
              }}</span>
            </v-toolbar>
          </v-card-title>
          <v-card-text slot="body">
            <v-layout wrap>
              <v-flex xs6 md5>
                <v-text-field
                  type="text"
                  class="t-field"
                  v-model="searchUserName"
                  :label="getString('Nome')"
                  solo
                  color="red lighten-3"
                />
              </v-flex>
              <v-flex xs6 md5>
                <v-text-field
                  type="text"
                  class="t-field"
                  v-model="searchUserSurname"
                  :label="getString('Cognome')"
                  solo
                  color="red lighten-3"
                />
              </v-flex>
              <v-flex xs12 md2>
                <v-btn
                  class="q-orange q-whitesmoke-bk bold"
                  @click="getNotificationUsers"
                  >Cerca</v-btn
                >
              </v-flex>
              <v-flex xs12>
                <v-data-table
                  :headers="[
                    { text: 'Data inviata', value: 'created' },
                    { text: 'Nome', value: 'name' },
                    { text: 'Cognome', value: 'surname' },
                    { text: 'Messaggio', value: 'message' },
                    { text: 'Letta', value: 'alreadyRead' },
                  ]"
                  :pagination.sync="notificationDefaultSorting"
                  :items="notificationUserList"
                  :items-per-page="10"
                  :loading="loadTable"
                  item-key="idCommunication"
                  :rows-per-page-text="getString('Date per pagina')"
                  :no-data-text="getString('Dati non disponibili')"
                  class="elevation-1"
                >
                  <template v-slot:progress>
                    <v-progress-linear
                      indeterminate
                      color="primary"
                    ></v-progress-linear>
                  </template>
                  <template slot="items" slot-scope="props">
                    <tr>
                      <td>{{ getFormattedDateTime(props.item.created) }}</td>
                      <td>
                        {{ props.item.name }}
                      </td>
                      <td>
                        {{ props.item.surname }}
                      </td>
                      <td>
                        {{ props.item.message }}
                      </td>
                      <td>{{ props.item.alreadyRead ? "SI" : "NO" }}</td>
                    </tr>
                  </template>
                </v-data-table>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions slot="footer">
            <v-btn
              class="q-orange q-whitesmoke-bk bold"
              @click.native="
                () => {
                  openNotificationRead = false;
                }
              "
              >{{ getString("Chiudi") }}</v-btn
            >
          </v-card-actions>
        </modal>

        <modal
          v-show="addNewDialog"
          @click="resetNewDialog"
          width="800"
          class="rounded-xl"
        >
          <v-card-title class="no-padding" slot="header">
            <v-toolbar color="red lighten-2" style="text-align: center">
              <span class="headline q-text-whitesmoke text-center">{{
                getString("Nuova prenotazione")
              }}</span>
            </v-toolbar>
          </v-card-title>
          <v-card-text slot="body">
            <v-layout wrap>
              <v-flex xs12 md12>
                <v-layout row wrap class="box-container">
                  <v-flex xs12 style="text-align: center">
                    <span class="headline center">{{ resDialogDay }}</span>
                  </v-flex>
                  <v-flex xs2 md2 lg2 style="text-align: center">
                    <h2>{{ getString("Ora") }}</h2>
                    <h3 style="font-size: 37px; margin-top: 3px">
                      {{ newRes.hour }}:
                    </h3>
                  </v-flex>
                  <v-flex xs3 md2 lg2>
                    <h2>{{ getString("minuti") }}</h2>
                    <v-select
                      style="font-size: 37px; width: 50px"
                      :menu-props="{
                        maxHeight: 500,
                        bottom: true,
                        offsetY: true,
                      }"
                      v-model="newMinute"
                      :items="getMinutesArray"
                      :label="null"
                    >
                      <template slot="selection" slot-scope="data">
                        <span style="margin-right: 30px">{{
                          data.item.value
                        }}</span>
                      </template>
                      <template slot="item" slot-scope="data">
                        <span
                          :class="{
                            'dedicate-triangle': data.item.isCool,
                            'dedicate-triangle-w': !data.item.isCool,
                          }"
                        ></span>
                        <span>{{ data.item.value }}</span>
                      </template>
                    </v-select>
                  </v-flex>

                  <v-flex
                    xs7
                    md8
                    lg6
                    v-if="!isDynamic"
                    style="align-content: center"
                  >
                    <span>
                      <div
                        class="dedicate-triangle"
                        style="display: inline-block"
                      ></div>
                      {{
                        getString(
                          "E' consigliato selezionare l'orario con questo simbolo per una gestione ottimale delle prenotazioni."
                        )
                      }}
                    </span>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-layout wrap style="margin-top: 10px">
                <v-flex xs12 v-if="waitingList.length > 0">
                  <span>Seleziona cliente dalla lista d'attesa</span>
                  <v-select
                    solo
                    v-model="selectWaitingListUser"
                    :items="waitingList"
                    item-text="fullName"
                    item-value="idUser"
                    return-object
                    v-on:change="compileForm"
                    :label="getString('Cliente in lista')"
                  ></v-select>
                </v-flex>
                <v-flex xs12>
                  <span v-if="waitingList.length > 0">oppure</span>
                  <v-autocomplete
                    color="red lighten-3"
                    solo
                    item-text="idUser"
                    item-key="idKey"
                    return-object
                    v-on:change="compileForm"
                    v-model="selectWaitingListUser"
                    :items="userapp"
                    :filter="customFilterUsers"
                    label="Seleziona utente"
                    :no-data-text="getString('Nessun utente trovato')"
                  >
                    <template v-slot:item="{ item }">
                      <img
                        :src="defaultAvatar(item)"
                        height="50"
                        width="50"
                        style="
                          margin-right: 5px;
                          object-fit: cover;
                          border-radius: 5px;
                        "
                      />
                      <div style="flex:1; display: flex; flex-direction: column">
                        <span>{{ item.fullName }}</span>
                        <span style="font-size: 11px; color: #999">(Tel: {{ item.phone }})</span>
                      </div>
                      <v-chip x-small :color="item._isManual ? 'blue-grey lighten-3' : 'green lighten-4'" text-color="grey darken-3" style="margin-left:8px; pointer-events:none">
                        <v-icon x-small left>{{ item._isManual ? 'edit' : 'phone_android' }}</v-icon>
                        {{ item._isManual ? 'Manuale' : 'App' }}
                      </v-chip>
                    </template>
                    <template v-slot:selection="{ item }">
                      <img
                        :src="defaultAvatar(item)"
                        height="100"
                        width="100"
                        :style="{
                          margin: '2px 10px 2px 2px',
                          objectFit: 'cover',
                          borderRadius: '10%',
                        }"
                      />
                      <span>{{ item.fullName }}</span>
                      <v-chip x-small :color="item._isManual ? 'blue-grey lighten-3' : 'green lighten-4'" text-color="grey darken-3" style="margin-left:8px">
                        <v-icon x-small left>{{ item._isManual ? 'edit' : 'phone_android' }}</v-icon>
                        {{ item._isManual ? 'Manuale' : 'App' }}
                      </v-chip>
                    </template>
                  </v-autocomplete>
                </v-flex>

                <v-flex xs12 v-if="!selectWaitingListUser.idUser">
                  <label>oppure inserisci i dati manualmente</label>
                </v-flex>
                <v-flex xs12>
                  <v-layout row wrap>
                    <!-- <v-flex
                      xs12
                      lg6
                      offset-lg3
                      v-if="selectWaitingListUser.photo"
                    >
                      <img
                        :src="defaultAvatar(selectWaitingListUser)"
                        class="avatar-img-small elevation-3"
                      />
                    </v-flex> -->
                    <v-flex xs12>
                      <v-layout row wrap>
                        <v-flex xs12 lg4>
                          <v-text-field
                            type="text"
                            class="t-field"
                            :disabled="disabledCompileUserData"
                            v-model="newName"
                            :label="getString('Nome')"
                            solo
                            color="red lighten-3"
                          />
                        </v-flex>
                        <v-flex xs12 lg4>
                          <v-text-field
                            type="text"
                            class="t-field"
                            v-model="newSurname"
                            :disabled="disabledCompileUserData"
                            :label="getString('Cognome')"
                            solo
                            color="red lighten-3"
                          />
                        </v-flex>
                        <v-flex xs12 lg4>
                          <v-text-field
                            type="text"
                            class=""
                            v-model="newPhone"
                            :disabled="disabledCompileUserData"
                            :label="getString('Telefono')"
                            solo
                            color="red lighten-3"
                          />
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs12>
                  <v-select
                    item-text="description"
                    item-value="idPrice"
                    v-model="newServices"
                    :items="services"
                    label="Seleziona il servizio"
                    multiple
                    return-object
                    :menu-props="{ bottom: true, offsetY: true }"
                    chips
                    variant="underlined"
                    solo
                  ></v-select>
                </v-flex>
                <v-flex xs12>
                  <v-textarea
                    solo
                    v-bind:label="getString('Nota')"
                    v-model="newNote"
                  ></v-textarea>
                </v-flex>

                <v-flex xs12>
                  <v-layout
                    :style="{
                      background: isDarkMode
                        ? 'var(--background-form)'
                        : 'white',
                      borderRadius: '10px',
                      padding: '0 10px',
                    }"
                    class="elevation-2"
                  >
                    <v-checkbox
                      color="#d5725b"
                      v-model="newRepeat"
                      style="white-space: nowrap"
                      :label="getString('Ripeti per ')"
                    ></v-checkbox>
                    <v-text-field
                      :rules="[
                        (v) =>
                          (v > 1 && v <= 50) ||
                          'Inserisci un numero tra 2 e 50',
                      ]"
                      class="centered-input"
                      v-model="weekRepeat"
                    ></v-text-field>
                    <span style="align-self: center; white-space: nowrap">
                      settimane ogni
                    </span>
                    <v-text-field
                      :rules="[
                        (v) =>
                          (v > 0 && v <= 4) || 'Inserisci un numero tra 1 e 4',
                      ]"
                      class="centered-input"
                      v-model="weekRepeatEach"
                    ></v-text-field>
                    <span style="align-self: center; white-space: nowrap"
                      >settimana/e</span
                    >
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-layout>
         
          </v-card-text>
          <v-card-actions slot="footer">
               <v-progress-linear
              indeterminate
              v-show="isLoading"
              :active="isLoading"
              :height="2"
            ></v-progress-linear>
            <v-layout style="justify-content: end; padding: 10px">
              <v-btn
                class="q-orange q-whitesmoke-bk bold"
                @click.native="resetNewDialog"
                >{{ getString("Annulla") }}</v-btn
              >

              <v-btn
                class="q-orange-bk q-text-whitesmoke bold"
                :disabled="isLoading"
                @click="addNewConfirm(false)"
                >{{ getString("Invia") }}</v-btn
              >
            </v-layout>
          </v-card-actions>
        </modal>

        <modal v-if="addNewDialogWaitingList" @click="resetNewDialog">
          <v-card-title class="no-padding" slot="header">
            <v-toolbar color="red lighten-2" style="text-align: center">
              <span class="headline q-text-whitesmoke text-center">{{
                getString("Dettagli richiesta")
              }}</span>
            </v-toolbar>
          </v-card-title>
          <v-card-text slot="body" style="padding: 0">
            <!-- Header cliente -->
            <div style="display:flex; align-items:center; gap:16px; padding:16px 20px; background: var(--background-form, #fafafa); border-bottom:1px solid #eee">
              <img
                :src="addNewDialogWaitingList.photo || '/../../../static/img/default-avatar.png'"
                onerror="this.src='/../../../static/img/default-avatar.png';"
                style="width:64px; height:64px; border-radius:50%; object-fit:cover; flex-shrink:0; border:2px solid #e57373"
              />
              <div>
                <div style="font-size:20px; font-weight:700; line-height:1.2">
                  {{ addNewDialogWaitingList.name }} {{ addNewDialogWaitingList.surname }}
                </div>
                <div style="font-size:13px; color:#888; margin-top:4px">
                  Verrà avvisato automaticamente in caso si liberi un posto.
                </div>
              </div>
            </div>

            <!-- Corpo dati -->
            <div style="padding:16px 20px">
              <v-layout wrap>
                <!-- Colonna sinistra -->
                <v-flex xs12 sm6 style="padding-right:12px">
                  <!-- Data richiesta -->
                  <div style="display:flex; align-items:center; gap:8px; margin-bottom:12px">
                    <v-icon color="red lighten-2" small>event</v-icon>
                    <div>
                      <div style="font-size:11px; color:#999; text-transform:uppercase; letter-spacing:.5px">Data richiesta</div>
                      <div style="font-weight:600">{{ getFormattedDate(addNewDialogWaitingList.day) }}</div>
                    </div>
                  </div>
                  <!-- Collaboratore -->
                  <div style="display:flex; align-items:center; gap:8px; margin-bottom:12px">
                    <v-icon color="red lighten-2" small>person_pin</v-icon>
                    <div>
                      <div style="font-size:11px; color:#999; text-transform:uppercase; letter-spacing:.5px">Collaboratore</div>
                      <div style="font-weight:600">{{ addNewDialogWaitingList.employeeName }}</div>
                    </div>
                  </div>
                  <!-- Telefono -->
                  <div style="display:flex; align-items:center; gap:8px; margin-bottom:12px">
                    <v-icon color="red lighten-2" small>phone</v-icon>
                    <div style="display:flex; align-items:center; gap:8px">
                      <div>
                        <div style="font-size:11px; color:#999; text-transform:uppercase; letter-spacing:.5px">Telefono</div>
                        <div style="font-weight:600">{{ addNewDialogWaitingList.phone }}</div>
                      </div>
                      <a target="_blank" :href="'https://wa.me/' + addNewDialogWaitingList.phone" style="line-height:0">
                        <img src="/../../../static/img/whatsapp.png" height="28" />
                      </a>
                    </div>
                  </div>
                </v-flex>

                <!-- Colonna destra -->
                <v-flex xs12 sm6>
                  <!-- Servizi -->
                  <div style="display:flex; align-items:flex-start; gap:8px; margin-bottom:12px">
                    <v-icon color="red lighten-2" small style="margin-top:2px">content_cut</v-icon>
                    <div>
                      <div style="font-size:11px; color:#999; text-transform:uppercase; letter-spacing:.5px">Servizi richiesti</div>
                      <div style="display:flex; flex-wrap:wrap; gap:4px; margin-top:4px">
                        <v-chip
                          v-for="s in addNewDialogWaitingList.servObject"
                          :key="s.idPrice"
                          small
                          color="red lighten-4"
                          text-color="red darken-3"
                        >{{ s.description }}</v-chip>
                      </div>
                    </div>
                  </div>
                  <!-- Nota -->
                  <div v-if="addNewDialogWaitingList.nota" style="display:flex; align-items:flex-start; gap:8px">
                    <v-icon color="red lighten-2" small style="margin-top:2px">notes</v-icon>
                    <div>
                      <div style="font-size:11px; color:#999; text-transform:uppercase; letter-spacing:.5px">Nota</div>
                      <div style="font-style:italic">{{ addNewDialogWaitingList.nota }}</div>
                    </div>
                  </div>
                </v-flex>
              </v-layout>
            </div>
            <v-progress-linear
              indeterminate
              v-show="isLoading"
              :active="isLoading"
              :height="2"
            ></v-progress-linear>
          </v-card-text>
          <v-card-actions slot="footer">
            <v-spacer></v-spacer>
            <v-btn
              class="q-orange q-whitesmoke-bk bold"
              @click.native="resetNewDialog"
              >{{ getString("Chiudi") }}</v-btn
            >
          </v-card-actions>
        </modal>

        <modal v-show="addNewConfirmDialog" @click="resetNewDialog">
          <v-card-title class="no-padding" slot="header">
            <v-toolbar color="red lighten-2" style="text-align: center">
              <span class="headline q-text-whitesmoke text-center">{{
                getString(`Attenzione`)
              }}</span>
            </v-toolbar>
          </v-card-title>
          <v-card-text slot="body">
            <v-layout wrap>
              <v-flex xs12>
                <span class="headline">{{
                  getString(
                    `Esiste già una prenotazione che va in conflitto con quella appena creata, sicuro di volerla inserire ugualmente?`
                  )
                }}</span>
              </v-flex>
            </v-layout>
            <v-progress-linear
              indeterminate
              v-show="isLoading"
              :active="isLoading"
              :height="2"
            ></v-progress-linear>
          </v-card-text>
          <v-card-actions slot="footer">
            <v-btn
              class="q-orange"
              flat
              @click.native="
                () => {
                  addNewConfirmDialog = false;
                }
              "
              >{{ getString("No") }}</v-btn
            >
            <v-spacer></v-spacer>
            <v-btn
              class="q-orange"
              :disabled="isLoading"
              flat
              @click="
                () => {
                  addNewConfirmDialog = false;
                  addNewConfirm(true);
                }
              "
              >{{ getString("Conferma") }}</v-btn
            >
          </v-card-actions>
        </modal>
      </div>
    </div>
    <div v-if="isExpired && !isAdmin">
      <p>
        Il tuo abbonamento è terminato. Vai nella sezione pagamenti e rinnova
        subito.
      </p>
    </div>
  </div>
</template>

<script>
import Utils from "../../utils.js";
import ajax from "../../ajax.js";
import fscreen from "fscreen";
import card from "./pieces/CalCard";
import cell from "./pieces/CalCell";
import column from "./pieces/CalCol";
import Modal from "../utils/Modal";
import Moment from "moment";
import ProgressQ from "./ProgressQ";
import Editor from "@tinymce/tinymce-vue";
import ShopUsers from "./pieces/ShopUsers";

var ut = new Utils();
export default {
  name: "Calendar",
  components: {
    card,
    cell,
    column,
    Modal,
    ProgressQ,
    editor: Editor,
    ShopUsers,
  },
  mounted: function () {
    
     
       
     
    
    //this.selectedShop = this.$route.params.id;
    this.currentGUIID = ut.GenerateUUID();
    if (this.selectedShop > 0) {
      this.getTimesArray();
      this.getUserApp();
    }
    if (fscreen.fullscreenEnabled) {
      fscreen.removeEventListener("fullscreenchange");
      fscreen.onfullscreenchange = this.fsChange;
    } else {
      this.showFullButtons = false;
      // this.$emit(
      //   "siteAlertInfo",
      //   this.getString("Modalità a schermo intero non supportata")
      // );
    }
    this.audioCtx = new (window.AudioContext || window.webkitAudioContext)();
  },
  watch: {
    serviceColor: {
      handler(val) {
        localStorage.setItem("serviceColor", JSON.stringify(val));
      },
      immediate: true,
    },
    ferieEmpId: function () {
      if (this.showFerieDialog) {
        this.loadFerieList();
      }
    },
    selectedShop: function () {
      if (this.selectedShop > 0) {
          // ajax.axios
          //   .get(ajax.baseUrl() + "/admin/shops/shop/" + this.selectedShop + "/options", {
          //     headers: this.$store.getters.tokenHeader,
          //     withCredentials: true,
          //   })
          //   .then((response) => {
          //     ajax.validateToken(response.headers, this.$store);
          //     const opt = response.data.data || response.data;
          //     const enabled = opt && (opt.NewPanel === true || opt.newPanel === true || opt.NewPanel === "True" || opt.newPanel === "True");
          //     if (enabled) {
          //       // redirect to silent-login for new panel
          //       window.location.href = "https://portale2.quickbe.app/silent-login?token=" + this.$store.getters.token;
          //     }
          //   })
          //   .catch(() => {});
        
        this.getTimesArray();
        this.getUserApp();
      }
    },
    // userAppSel: function(){
    //   if (this.userAppSel)
    //   {
    //     this.newName = this.userAppSel.name
    //     this.newSurname = this.userAppSel.surname
    //     this.newPhone = this.userAppSel.phone
    //     this.disabledCompileUserData = true
    //   }
    // }
  },
  computed: {
    isDarkMode: function () {
      return localStorage.getItem("darkMode") ? true : false;
    },
    selectedShop: function () {
      if (this.$store.getters.myShop)
        return this.$store.getters.myShop.idBarberShop;
    },
    waitingListExist: function () {
      if (this.waitingList) return this.waitingList.length > 0;
      return false;
    },
    multiDetailGroups: function () {
      const groups = {};
      this.multiDetailCards.forEach((card, index) => {
        const services = this.getMultiCardServices(card);
        services.forEach((service) => {
          if (!groups[service]) {
            groups[service] = {
              service: service,
              items: [],
            };
          }
          groups[service].items.push({
            card: card,
            originalIndex: index,
          });
        });
      });
      return Object.keys(groups)
        .sort((a, b) => a.localeCompare(b))
        .map((key) => groups[key]);
    },
    countChar: function () {
      return (
        this.getString("Caratteri: ") +
        this.stripHtml(this.newNotificationBody.message).length
      );
    },
    countCharTitle: function () {
      return (
        this.getString("Caratteri: ") +
        this.stripHtml(this.newNotificationBody.title).length
      );
    },
    toPublish: function () {
      return this.$store.getters.shopState === 2;
    },
    expiringDays: function () {
      if (this.$store.getters.myShop !== null)
        return Moment(this.$store.getters.myShop.expired).diff(
          Moment(),
          "days"
        );
      return 0;
    },
    isExpired: function () {
      if (this.$store.getters.myShop !== null)
        return this.$store.getters.myShop.isExpired;
      else return false;
    },
    isAdmin: function () {
      return this.$store.getters.isAdmin;
    },
    hoursTotal: function () {
      let temp = [
        "00",
        "01",
        "02",
        "03",
        "04",
        "05",
        "06",
        "07",
        "08",
        "09",
        "10",
        "11",
        "12",
        "13",
        "14",
        "15",
        "16",
        "17",
        "18",
        "19",
        "20",
        "21",
        "22",
        "23",
      ];
      let result = [];
      for (let index = 0; index < temp.length; index++) {
        const element = temp[index];
        if (
          Number.parseInt(this.minTime.split(":")[0]) <=
            Number.parseInt(element) &&
          Number.parseInt(this.maxTime.split(":")[0]) >=
            Number.parseInt(element)
        ) {
          result.push(element);
        }
      }
      return result;
    },
    locale: function () {
      return this.$store.state.currentTranslator.locale;
    },
    minutesTotal: function () {
      return [
        "00",
        "05",
        "10",
        "15",
        "20",
        "25",
        "30",
        "35",
        "40",
        "45",
        "50",
        "55",
      ];
    },
    isCardRealUser: function () {
      if (this.sCard) return this.sCard.selectedCard.referenceUsers > 0;
      return false;
    },
    moveText: function () {
      return (
        this.getString("Spostamento in corso per ") +
        "<b>" +
        (this.sCard !== null ? this.sCard.fullName : "") +
        "</b>"
      );
    },
    moving: function () {
      return this.sCard !== null;
    },
    headerWidth: function () {
      return 280 * this.emps.length + 47;
    },
    isFullscreen: function () {
      return this.$store.state.isFullscreen;
    },
    getMinutesArray: function () {
      if (this.newRes.day !== "") {
        const self = this;
        const day = ut.First(this.times, (x) => {
          return x.day === self.newRes.dow;
        });
        if (this.newRes.isFirst) {
          return [
            {
              value: "00",
              isCool: this.getIsCool(
                day.openTimeMorning,
                day.openTimeAft,
                this.newRes.hour + ":00"
              ),
            },
            {
              value: "05",
              isCool: this.getIsCool(
                day.openTimeMorning,
                day.openTimeAft,
                this.newRes.hour + ":05"
              ),
            },
            {
              value: "10",
              isCool: this.getIsCool(
                day.openTimeMorning,
                day.openTimeAft,
                this.newRes.hour + ":10"
              ),
            },
            {
              value: "15",
              isCool: this.getIsCool(
                day.openTimeMorning,
                day.openTimeAft,
                this.newRes.hour + ":15"
              ),
            },
            {
              value: "20",
              isCool: this.getIsCool(
                day.openTimeMorning,
                day.openTimeAft,
                this.newRes.hour + ":20"
              ),
            },
            {
              value: "25",
              isCool: this.getIsCool(
                day.openTimeMorning,
                day.openTimeAft,
                this.newRes.hour + ":25"
              ),
            },
          ];
        } else {
          return [
            {
              value: "30",
              isCool: this.getIsCool(
                day.openTimeMorning,
                day.openTimeAft,
                this.newRes.hour + ":30"
              ),
            },
            {
              value: "35",
              isCool: this.getIsCool(
                day.openTimeMorning,
                day.openTimeAft,
                this.newRes.hour + ":35"
              ),
            },
            {
              value: "40",
              isCool: this.getIsCool(
                day.openTimeMorning,
                day.openTimeAft,
                this.newRes.hour + ":40"
              ),
            },
            {
              value: "45",
              isCool: this.getIsCool(
                day.openTimeMorning,
                day.openTimeAft,
                this.newRes.hour + ":45"
              ),
            },
            {
              value: "50",
              isCool: this.getIsCool(
                day.openTimeMorning,
                day.openTimeAft,
                this.newRes.hour + ":50"
              ),
            },
            {
              value: "55",
              isCool: this.getIsCool(
                day.openTimeMorning,
                day.openTimeAft,
                this.newRes.hour + ":55"
              ),
            },
          ];
        }
      }
    },
    resDialogDay: function () {
      if (this.newRes.day !== "") {
        for (let index = 0; index < this.days.length; index++) {
          const element = this.days[index];
          if (element.day.split("T")[0].split("-")[2] === this.newRes.day) {
            return this.getDayName(
              Number.parseInt(element.dayOfWeek),
              element.day.split("T")[0]
            );
          }
        }
      }
      return "";
    },
    hasFidelityDlc: {
      get: function () {
        return this.$store.getters.hasDlc("D0");
      },
    },
    isAdmin: function () {
      return this.$store.getters.isAdmin;
    },
  },
  data: () => {
    return {
    showExpiredDialog: true,
    showNewPanelDialog: true,
      isImageClicked: false,
      addNewConfirmDialog: false,
      addNewDialog: false,
      addNewDialogWaitingList: null,
      multiDetailsDialog: false,
      multiDetailCards: [],
      multiDetailsCardRef: null,
      allCards: [],
      audioCtx: null,
      audioShowed: false,
      addNoteDialog: false,
      bar: true,
      busyMinutes: 30,
      confirmBan: false,
      confirmDelete: false,
      confirmDeletePc: false,
      copied: false,
      count: 0,
      currentGUIID: "",
      dateChoose: false,
      days: [],
      detailsDialog: false,
      fidelityPointDialog: false,
      detCard: {
        selectedCard: {},
      },
      selectedService: [],
      disabledCompileUserData: false,
      emps: [],
      ferieEmpId: null,
      ferieDateStart: new Moment().format("YYYY-MM-DD"),
      ferieDateEnd: new Moment().format("YYYY-MM-DD"),
      ferieDp1: false,
      ferieDp2: false,
      ferieMessage: "",
      ferieShowEditor: false,
      ferieIsDisabling: false,
      showFerieDialog: false,
      ferieList: [],
      ferieListLoading: false,
      ferieMessagePopup: "",
      showFerieMessagePopup: false,
      headerLeftMargin: 24,
      isDynamic: true,
      isLoading: false,
      isSavingNote: false,
      loadedCells: 0,
      loadTable: false,
      loadTable2: false,
      mainLoad: false,
      maxTime: "23:59",
      minTime: "00:00",
      moveDate: new Moment().format("YYYY-MM-DD"),
      moveEmp: 0,
      moveHour: "",
      moveServices: [],
      moveInfo: false,
      moveMin: "",
      notifyUser: true,
      newMinute: "",
      newNoteAuthor: "",
      newNoteText: "",
      newName: "",
      newNote: "",
      oldNote: "",
      newGlobalNote: "",
      newGlobalNoteAuthor: "",
      globalNotes: [],
      isSavingGlobalNote: false,
      confirmDeleteNoteDialog: false,
      pendingDeleteNoteId: null,
      noteAuthorSuggestions: [],
      notificationDefaultSorting: {
        descending: true,
        sortyBy: "alreadyRead",
      },
      newNotificationBody: {
        title: "Comunicazione",
        message: "",
      },
      newPhone: "",
      newRepeat: false,
      newRes: {
        isFirst: true,
        hour: "0",
        emp: {},
        day: "",
        dow: 0,
      },
      newServices: [],
      newSurname: "",
      openSearchUser: false,
      openClientsList: false,
      openSchedaUser: false,
      openWaitingList: false,
      openNotificationRead: false,
      openSettingsModel: false,
      poolAudio: "/static/audio/sweet.wav",
      poolData: null,
      poolHandler: null,
      reservationUserList: [],
      usersAll: [],
      notificationUserList: [],
      resv: [],
      sCard: null,
      searchUserName: "",
      searchUserSurname: "",
      selectedPoint: 0,
      // selectedShop: 0,
      selectWaitingListUser: {},
      sendNotificationPopup: false,
      services: [],
      serviceColor: localStorage.getItem("serviceColor") === "true",
      initialSwitchState: null,
      showFullButtons: true,
      startDate: new Moment().format("YYYY-MM-DD"),
      times: [],
      userapp: [],
      userAppSel: null,
      waitingList: [],
      weekRepeat: 10,
      weekRepeatEach: 1,
      ut: new Utils(),
      resNotificationsNew: [],
      resNotificationsDel: [],
    };
  },
  // },
  // watch: {
  //   startDate: function() {
  //     this.resetAll()
  //     this.getTimesArray()
  //     this.dateChoose = false
  //   }
  // },
  beforeDestroy: function () {
    clearInterval(this.poolHandler);
  },
  methods: {
    handleActivateNewPanel: function () {
      var self = this;
      if (!this.selectedShop || this.selectedShop <= 0) {
        this.siteAlert(this.getString("Seleziona un negozio"));
        return;
      }
      // call backend to set NewPanel = true for this shop
      ajax.axios
        .put(
          ajax.baseUrl() + "/admin/shops/shop/" + this.selectedShop + "/options",
          { newPanel: true },
          {
            headers: { Authorization: "Bearer " + this.$store.getters.token },
            withCredentials: true,
          }
        )
        .then(function (response) {
          ajax.validateToken(response.headers, self.$store);
          // proceed with existing behavior (silent login)
          window.location.reload()
        })
        .catch(function (error) {
          var auth = ajax.checkAuth(error, self.$store, self.$router);
          self.siteAlert(auth ? self.getString("Non hai l'autorizzazione") : (error.response && error.response.data && error.response.data.errorMessage) || "Errore");
        });
    },
    customFilterUsers(item, queryText, itemText) {
      const searchText = queryText.toLowerCase();
      const wordsSearch = searchText.split(" ");
      const fullName = item.fullName.toLowerCase();
     
      return wordsSearch.every(word => fullName.includes(word));
    },
    handleShowFerieDialog: function () {
      this.ferieEmpId = this.emps.length > 0 ? this.emps[0].employees.idEmployee : null;
      this.ferieDateStart = new Moment(this.startDate).format("YYYY-MM-DD");
      this.ferieDateEnd = new Moment(this.startDate).format("YYYY-MM-DD");
      this.ferieMessage = "";
      this.showFerieDialog = true;
      this.$nextTick(() => {
        this.ferieShowEditor = true;
      });
      this.loadFerieList();
    },
    loadFerieList: function () {
      let self = this;
      if (!self.ferieEmpId) return;
      self.ferieListLoading = true;
      ajax.axios
        .get(
          ajax.baseUrl() +
            "/admin/calendar/shop/" +
            self.selectedShop +
            "/employee/" +
            self.ferieEmpId +
            "/vacations",
          {
            headers: { Authorization: "Bearer " + self.$store.getters.token },
            withCredentials: true,
          }
        )
        .then(function (response) {
          ajax.validateToken(response.headers, self.$store);
          const days = (response.data.data || []).map(x => ({
            date: x.date ? x.date.split("T")[0] : x.Date.split("T")[0],
            message: x.message || x.Message || "",
          }));
          // group consecutive dates with same message into ranges
          const groups = [];
          days.forEach(d => {
            if (groups.length === 0) {
              groups.push({ from: d.date, to: d.date, message: d.message });
            } else {
              const last = groups[groups.length - 1];
              const lastDate = new Moment(last.to);
              const curDate = new Moment(d.date);
              if (curDate.diff(lastDate, "days") === 1 && d.message === last.message) {
                last.to = d.date;
              } else {
                groups.push({ from: d.date, to: d.date, message: d.message });
              }
            }
          });
          self.ferieList = groups;
          self.ferieListLoading = false;
        })
        .catch(function () {
          self.ferieListLoading = false;
        });
    },
    deleteFerieRange: function (from, to) {
      let self = this;
      ajax.axios
        .put(
          ajax.baseUrl() +
            "/admin/calendar/shop/" +
            self.selectedShop +
            "/employee/" +
            self.ferieEmpId +
            "/from/" +
            from +
            "/to/" +
            to +
            "/enable/",
          {},
          {
            headers: { Authorization: "Bearer " + self.$store.getters.token },
            withCredentials: true,
          }
        )
        .then(function (response) {
          ajax.validateToken(response.headers, self.$store);
          self.getEmpArray();
          self.loadFerieList();
        })
        .catch(function (error) {
          var auth = ajax.checkAuth(error, self.$store, self.$router);
          self.siteAlert(
            auth
              ? self.getString("Non hai l'autorizzazione")
              : error.response.data.errorMessage
          );
        });
    },
    saveFerieFromCalendar: function () {
      let self = this;
      if (!self.ferieEmpId) {
        self.siteAlert(self.getString("Seleziona un dipendente"));
        return;
      }
      if (self.ferieIsDisabling) {
        self.siteAlert(self.getString("Operazione già in corso, attendi che finisca"));
        return;
      }
      self.ferieIsDisabling = true;
      ajax.axios
        .put(
          ajax.baseUrl() +
            "/admin/calendar/shop/" +
            self.selectedShop +
            "/employee/" +
            self.ferieEmpId +
            "/from/" +
            self.ferieDateStart +
            "/to/" +
            self.ferieDateEnd +
            "/disable/",
          { message: self.ferieMessage },
          {
            headers: { Authorization: "Bearer " + self.$store.getters.token },
            withCredentials: true,
          }
        )
        .then(function (response) {
          ajax.validateToken(response.headers, self.$store);
          self.showFerieDialog = false;
          self.ferieShowEditor = false;
          self.ferieList = [];
          if (response) {
            self.getEmpArray();
          }
          setTimeout(() => { self.ferieIsDisabling = false; }, 200);
        })
        .catch(function (error) {
          var auth = ajax.checkAuth(error, self.$store, self.$router);
          self.siteAlert(
            auth
              ? self.getString("Non hai l'autorizzazione")
              : error.response.data.errorMessage
          );
          setTimeout(() => { self.ferieIsDisabling = false; }, 200);
        });
    },
    closeSettingsModal: function() {
      this.openSettingsModel = false;
      if (
        this.initialSwitchState &&
        this.initialSwitchState.serviceColor !== this.serviceColor
      ) {
        window.location.reload();
      }
    },
    getUserApp: function () {
      let self = this;
      if (this.selectedShop > 0) {
        this.shopLoad = true;
        ajax.axios
          .get(
            ajax.baseUrl() +
              "/admin/shops/shop/" +
              this.selectedShop +
              "/clients",
            {
              headers: self.$store.getters.tokenHeader,
              withCredentials: true,
            }
          )
          .then(function (response) {
            ajax.validateToken(response.headers, self.$store);
            self.shopLoad = false;
            const data = response.data.data;
            const registered = (data.registered || [])
              .filter((x) => !x.isBanned)
              .map((x) => Object.assign({}, x, { _isManual: false, idKey: x.idUser }));
            const manual = (data.manual || [])
              .map((x) => Object.assign({}, x, { _isManual: true, idKey: x.idCrmClient * -1 }));
            self.userapp = registered.concat(manual);
           
          })
          .catch(function (error) {
            var auth = ajax.checkAuth(error, self.$store, self.$router);
            self.shopLoad = false;
            self.$emit(
              "siteAlert",
              auth
                ? self.getString("Non hai l'autorizzazione")
                : error.response.data.errorMessage
            );
          });
      }
    },
    updateScore: function () {
      try {
        var self = this;
        var newPoints = Number.parseInt(this.selectedPoint);
        if (!Number.isInteger(newPoints)) {
          this.$emit("siteAlert", "Numero non valido");
          return;
        }

        self.isLoading = true;
        ajax.axios
          .put(
            ajax.baseUrl() +
              "/admin/fid/reservation/" +
              self.detCard.selectedCard.idReservation +
              "/add/" +
              newPoints,
            {},
            {
              headers: self.$store.getters.tokenHeader,
              withCredentials: true,
            }
          )
          .then(function (response) {
            self.$emit("siteAlertSuccess", "Aggiornato");
            self.fidelityPointDialog = false;
          })
          .catch(function (error) {
            var auth = ajax.checkAuth(error, self.$store, self.$router);
            self.$emit(
              "siteAlert",
              auth
                ? self.getString("Non hai l'autorizzazione")
                : error.response.data.errorMessage
            );
          })
          .finally(function () {
            self.isLoading = false;
          });
      } catch (error) {
        console.log(error);
      }
    },
    showWarningSeriesRes: function (card) {
      return (
        !card.isLastOne && card.lastReservationDate
        // && this.getDiffDays(card.lastReservationDate, card.dateAndTime) < 60
      );
    },
    getDiffDays: function (date, date2) {
      const m2 = new Moment(date2);
      const diffDays = new Moment(date).diff(m2, "days");
      return diffDays;
    },
    getFormattedDate: function (date) {
      return new Moment(date).format("DD/MM/YYYY");
    },
    getFormattedDateTime: function (date) {
      return new Moment(date).format("DD/MM/YYYY HH:mm");
    },
    getCalendarMinute: function (item) {
      return Number.parseInt(item) < 30 ? "00" : "30";
    },
    getIsCool: function (opening, closing, now) {
      const id = this.newRes.emp;
      const emp = this.emps.find((x) => x.employees.idEmployee === id);
      const intervallo =
        emp.employees.minIntervalloEmployee > 0
          ? emp.employees.minIntervalloEmployee
          : this.busyMinutes;

      if (this.isDynamic) return false;
      const openingMoment = Moment(opening, "HH:mm");
      const closingMoment = Moment(closing, "HH:mm");
      const nowMoment = Moment(now, "HH:mm");
      if (nowMoment.isSameOrAfter(closingMoment)) {
        return nowMoment.diff(closingMoment, "m") % intervallo === 0;
      }
      return nowMoment.diff(openingMoment, "m") % intervallo === 0;
    },
    changeDate: function () {
      this.resetAll();
      let self = this;
      this.dateChoose = false;

      this.getTimesArray();
    },
    getItalianDate(date) {
      return new Moment(date).locale("it").format("DD MMMM YYYY");
    },
    initAudio: function () {
      if (this.audioCtx.state !== "running") audioCtx.resume();
    },
    playAudio: function () {
      let self = this;
      if (this.audioCtx !== null) {
        var source = this.audioCtx.createBufferSource();
        ajax.axios
          .get(self.poolAudio, {
            responseType: "arraybuffer",
            withCredentials: true,
          })
          .then(function (response) {
            ajax.validateToken(response.headers, self.$store);
            self.audioCtx.decodeAudioData(response.data, function (buffer) {
              source.buffer = buffer;
              source.connect(self.audioCtx.destination);
              source.loop = false;
              source.start(0);
              if (self.audioCtx.state === "running") {
              } else {
                if (!self.audioShowed) {
                  self.audioShowed = true;
                }
              }
            });
          })
          .catch(function (error) {
            console.log(error);
            console.log(error.status);
            console.log(error.message);
          });
      }
    },
    playAudioDelete: function () {
      let self = this;
      if (this.audioCtx !== null) {
        var source = this.audioCtx.createBufferSource();
        ajax.axios
          .get(self.poolAudioDelete, {
            responseType: "arraybuffer",
            withCredentials: true,
          })
          .then(function (response) {
            ajax.validateToken(response.headers, self.$store);
            self.audioCtx.decodeAudioData(response.data, function (buffer) {
              source.buffer = buffer;
              source.connect(self.audioCtx.destination);
              source.loop = false;
              source.start(0);
              if (self.audioCtx.state === "running") {
              } else {
                if (!self.audioShowed) {
                  self.audioShowed = true;
                }
              }
            });
          })
          .catch(function (error) {
            console.log(error);
            console.log(error.status);
            console.log(error.message);
          });
      }
    },
    openSchedaUtente: function (item) {
      this.reservationUserList = [];
      this.searchUserReservations(item);
      this.openSchedaUser = true;
      //  this.openSearchUser = false;
    },

    goToReservation: function (item) {
      const self = this;

      // Close any open modals first to avoid layout interference
      self.openSearchUser = false;
      self.openSchedaUser = false;

      const dt = new Moment(item.dateAndTime);
      const dateStr = dt.format("YYYY-MM-DD");

      const isInCurrentWeek = self.days.length > 0 &&
        self.days.some(d => d.day.split("T")[0] === dateStr);

      const doScroll = function () {
        const container = self.$refs.mainFlex;
        if (!container) return;
        // Find the actual CalCell component for this reservation
        var coord = self.getCardCoordByResv(item);
        var cell = self.getCardBySelected(coord.day, coord.emp, coord.hour, coord.min);
        if (cell && cell.$el) {
          var cellRect = cell.$el.getBoundingClientRect();
          var containerRect = container.getBoundingClientRect();
          // Absolute position of the cell within the scrollable area
          var cellTop = container.scrollTop + (cellRect.top - containerRect.top);
          var cellLeft = container.scrollLeft + (cellRect.left - containerRect.left);
          // Center the cell in the visible viewport
          var targetTop = Math.max(0, cellTop - container.clientHeight / 2 + cellRect.height / 2);
          var targetLeft = Math.max(0, cellLeft - container.clientWidth / 2 + cellRect.width / 2);
          container.scrollTo({ top: targetTop, left: targetLeft, behavior: "smooth" });
        }
      };

      // Double requestAnimationFrame after a delay ensures DOM is fully laid out
      const scrollAfterRender = function (delay) {
        setTimeout(function () {
          self.$nextTick(function () {
            requestAnimationFrame(function () {
              requestAnimationFrame(doScroll);
            });
          });
        }, delay);
      };

      if (isInCurrentWeek) {
        // Same week: DOM already rendered, just wait a frame
        scrollAfterRender(50);
      } else {
        self.startDate = dateStr;
        self.changeDate();
        // Watch mainLoad: fires when getPrices completes (all data loaded)
        // Then wait 400ms for Vue to render all CalCol/CalCell sub-components
        const unwatch = self.$watch("mainLoad", function (val) {
          if (val === false) {
            unwatch();
            scrollAfterRender(400);
          }
        });
      }
    },
    formatNotifyDate: function (dt) {
      return new Moment(dt).format("DD/MM/YYYY HH:mm");
    },
    showSuccess: function (resv) {
      if (this.resNotificationsNew.length > 0) {
        for (let i = 0; i < resv.length; i++) {
          this.resNotificationsNew[0].items.push(resv[i]);
        }
      } else {
        this.resNotificationsNew.push({ items: resv.slice() });
      }
    },
    getNotes: function () {
      var self = this;
      ajax.axios
        .get(
          ajax.baseUrl() +
            "/admin/shops/shop/" +
            self.selectedShop +
            "/clients/client/" +
            self.detCard.selectedCard.referenceUsers +
            "/notes",
          {
            headers: { Authorization: "Bearer " + self.$store.getters.token },
            withCredentials: true,
          }
        )
        .then(function (response) {
          ajax.validateToken(response.headers, self.$store);
          self.globalNotes = response.data.data || [];
          // Raccoglie autori per autocompletamento
          var authors = self.globalNotes.map(function (n) { return n.author; }).filter(function (a) { return a && a.length > 0; });
          self.noteAuthorSuggestions = [...new Set(authors)];
        })
        .catch(function (error) {
          var auth = ajax.checkAuth(error, self.$store, self.$router);
          self.$emit("siteAlert", auth ? self.getString("Non hai l'autorizzazione") : error.response.data.errorMessage);
        });
    },
    addNote: function () {
      var self = this;
      if (!self.newNoteText.trim()) return;
      self.isSavingNote = true;
      ajax.axios
        .post(
          ajax.baseUrl() +
            "/admin/shops/shop/" +
            self.selectedShop +
            "/clients/client/" +
            self.detCard.selectedCard.referenceUsers +
            "/notes",
          { note: self.newNoteText.trim(), author: self.newNoteAuthor.trim() },
          {
            headers: { Authorization: "Bearer " + self.$store.getters.token },
            withCredentials: true,
          }
        )
        .then(function (response) {
          ajax.validateToken(response.headers, self.$store);
          self.globalNotes = response.data.data || [];
          self.newNoteText = "";
          self.newNoteAuthor = "";
          self.addNoteDialog = false;
          self.$emit("siteAlertSuccess", self.getString("Nota aggiunta"));
        })
        .catch(function (error) {
          var auth = ajax.checkAuth(error, self.$store, self.$router);
          self.$emit("siteAlert", auth ? self.getString("Non hai l'autorizzazione") : error.response.data.errorMessage);
        })
        .finally(function () { self.isSavingNote = false; });
    },
    addGlobalNote: function () {
      var self = this;
      if (!self.newGlobalNote.trim()) return;
      self.isSavingGlobalNote = true;
      ajax.axios
        .post(
          ajax.baseUrl() +
            "/admin/shops/shop/" +
            self.selectedShop +
            "/clients/client/" +
            self.detCard.selectedCard.referenceUsers +
            "/notes",
          { note: self.newGlobalNote.trim(), author: self.newGlobalNoteAuthor.trim() },
          {
            headers: { Authorization: "Bearer " + self.$store.getters.token },
            withCredentials: true,
          }
        )
        .then(function (response) {
          ajax.validateToken(response.headers, self.$store);
          self.globalNotes = response.data.data || [];
          self.newGlobalNote = "";
          self.$emit("siteAlertSuccess", self.getString("Nota aggiunta"));
        })
        .catch(function (error) {
          var auth = ajax.checkAuth(error, self.$store, self.$router);
          self.$emit("siteAlert", auth ? self.getString("Non hai l'autorizzazione") : error.response.data.errorMessage);
        })
        .finally(function () { self.isSavingGlobalNote = false; });
    },
    deleteGlobalNote: function (idNote) {
      var self = this;
      ajax.axios
        .delete(
          ajax.baseUrl() +
            "/admin/shops/shop/" +
            self.selectedShop +
            "/clients/client/" +
            self.detCard.selectedCard.referenceUsers +
            "/notes/" + idNote,
          {
            headers: { Authorization: "Bearer " + self.$store.getters.token },
            withCredentials: true,
          }
        )
        .then(function (response) {
          ajax.validateToken(response.headers, self.$store);
          self.globalNotes = self.globalNotes.filter(function (n) { return n.idNote !== idNote; });
        })
        .catch(function (error) {
          var auth = ajax.checkAuth(error, self.$store, self.$router);
          self.$emit("siteAlert", auth ? self.getString("Non hai l'autorizzazione") : error.response.data.errorMessage);
        });
    },
    formatNoteDate: function (d) {
      if (!d) return "";
      var m = new Moment(d);
      return m.isValid() ? m.format("DD/MM/YYYY HH:mm") : "";
    },
    saveNote: function () {
      var self = this;
      if (self.newNote !== self.oldNote) {
        self.isLoading = true;
        ajax.axios
          .put(
            ajax.baseUrl() +
              "/admin/calendar/reservation/" +
              self.detCard.selectedCard.idReservation +
              "/note",
            {
              note: self.newNote,
            },
            {
              headers: {
                Authorization: "Bearer " + self.$store.getters.token,
              },
              withCredentials: true,
            }
          )
          .then(function (response) {
            ajax.validateToken(response.headers, self.$store);
            self.detCard.selectedCard.note = self.newNote;
            self.isLoading = false;
            self.$emit("siteAlertSuccess", response.data.data);
          })
          .catch(function (error) {
            self.isLoading = false;
            var auth = ajax.checkAuth(error, self.$store, self.$router);
            self.$emit(
              "siteAlert",
              auth
                ? self.getString("Non hai l'autorizzazione")
                : error.response.data.errorMessage
            );
          });
      }
    },

    showDel: function (resv) {
      if (this.resNotificationsDel.length > 0) {
        for (let i = 0; i < resv.length; i++) {
          this.resNotificationsDel[0].items.push(resv[i]);
        }
      } else {
        this.resNotificationsDel.push({ items: resv.slice() });
      }
    },
    initPooling: function () {
      this.poolData = localStorage.getItem("p_data");
      if (this.poolData === null) {
        this.poolData = new Moment().format("YYYY-MM-DD[T]HH:mm:ss");
        localStorage.setItem("p_data", this.poolData);
      }
      
      // Cancella il timer precedente se esiste per evitare duplicazione
      if (this.poolHandler) {
        clearInterval(this.poolHandler);
      }
      
      this.ajaxPooling();
      this.poolHandler = setInterval(this.ajaxPooling, 30000);
      //this.poolHandler = setTimeout(this.ajaxPooling, 1000);
    },
    ajaxPooling: function () {
      let self = this;
      ajax.axios
        .get(
          ajax.baseUrl() +
            "/admin/calendar/shop/" +
            self.selectedShop +
            "/pooling/" +
            self.poolData,
          {
            headers: {
              Authorization: "Bearer " + self.$store.getters.token,
            },
            withCredentials: true,
          }
        )
        .then(function (response) {
          ajax.validateToken(response.headers, self.$store);
          let news = response.data.data.new;
          let del = response.data.data.del;
          self.poolData = response.data.data.newDate;
          self.waitingList = response.data.data.waitingList;
          localStorage.setItem("p_data", self.poolData);
          
          // //test
          // for (let index = 0; index < 2; index++) {
          //   news.push({
          //     "phone": null,
          //     "email": null,
          //     "nameEmployee": "Nicole Marino",
          //     "photo": null,
          //     "uName": "aaaaaaa222223",
          //     "uSurname": "asd",
          //     "flyUser": 0,
          //     "idReservation": 992821,
          //     "dateAndTime": "2026-05-18T09:30:00",
          //     "dateEnd": "2026-05-18T09:50:00",
          //     "created": "2026-05-17T11:47:33",
          //     "updated": "2026-05-17T11:47:33",
          //     "referenceUsers": 50,
          //     "referenceCrmClient": 3,
          //     "referenceBarberShop": 1,
          //     "referenceEmployee": 37,
          //     "note": null,
          //     "servicesPrice": 10.0,
          //     "service": "Lavaggio",
          //     "flyName": "aaaaaaa222223",
          //     "flySurname": "asd",
          //     "flyPhone": "",
          //     "lastReservationDate": null,
          //     "isLastOne": false,
          //     "min": 20
          //   });
            
          // }
        
          if (news.length > 0 || del.length > 0) {
            var newsFiltered = news.filter((x) => x.referenceUsers > 0);
            var deleteFiltered = del.filter((x) => x.referenceUsers > 0);
            if (news.length > 0) {
              if (newsFiltered.length > 0) {
                self.playAudio();
                self.showSuccess(newsFiltered);
              }
            }
            if (del.length > 0) {
              if (deleteFiltered.length > 0) {
                self.playAudioDelete();
                self.showDel(deleteFiltered);
              }
            }
          }
          for (let index = 0; index < news.length; index++) {
            const element = news[index];
            let card = self.getCardCoordByResv(element);
            self.card(card.day, card.emp, card.hour, card.min, element, true);
          }
          for (let index = 0; index < del.length; index++) {
            const element = del[index];
            let card = self.getCardCoordByResv(element);
            let cardToDelete = self.getCardBySelected(
              card.day,
              card.emp,
              card.hour,
              card.min
            );
            if (cardToDelete !== null)
              cardToDelete.popCard(element.idReservation);
          }
          var now = new Moment();
          for (let index = 0; index < self.emps.length; index++) {
            const emp = self.emps[index];
            let oldCard = self.getCardBySelected(
              ut.NumberWith0(now.date()),
              emp.employees.idEmployee,
              ut.NumberWith0(now.hour()),
              ut.NumberWith0(Math.floor(now.minutes() / 5) * 5)
            );
            if (oldCard !== null) oldCard.hasPassed = true;
          }
        })
        .catch(function (error) {
          console.log(error);
          var auth = ajax.checkAuth(error, self.$store, self.$router);
          // self.$emit(
          //   "siteAlert",
          //   auth
          //     ? self.getString("Non hai l'autorizzazione")
          //     : error.response.data.errorMessage
          // );
        });
    },
    searchUser: function () {
      let self = this;
      self.loadTable = true;
      if (!this.searchUserName && !this.searchUserSurname) {
        self.$emit(
          "siteAlert",
          self.getString("Almeno un campo è obbligatorio")
        );
        self.loadTable = false;
        return;
      }
      ajax.axios
        .get(
          ajax.baseUrl() +
            "/admin/calendar/shops/" +
            self.selectedShop +
            "/users",
          {
            params: {
              name: self.searchUserName.trim(),
              surname: self.searchUserSurname.trim(),
            },
            headers: {
              Authorization: "Bearer " + self.$store.getters.token,
            },
            withCredentials: true,
          }
        )
        .then(function (response) {
          ajax.validateToken(response.headers, self.$store);
          self.usersAll = response.data.data.users;
        })
        .catch(function (error) {
          console.log(error);
          var auth = ajax.checkAuth(error, self.$store, self.$router);
          self.$emit(
            "siteAlert",
            auth
              ? self.getString("Non hai l'autorizzazione")
              : error.response.data.errorMessage
          );
        })
        .finally(function () {
          // Usa `finally` correttamente
          self.loadTable = false;
        });
    },
    searchUserReservations: function (item) {
      let self = this;
      self.loadTable2 = true;
      ajax.axios
        .post(
          ajax.baseUrl() +
            "/admin/calendar/shops/" +
            self.selectedShop +
            "/users/reservations",
          item,
          {
            headers: {
              Authorization: "Bearer " + self.$store.getters.token,
            },

            withCredentials: true,
          }
        )
        .then(function (response) {
          ajax.validateToken(response.headers, self.$store);
          self.reservationUserList = response.data.data.users;
        })
        .catch(function (error) {
          console.log(error);
          var auth = ajax.checkAuth(error, self.$store, self.$router);
          self.$emit(
            "siteAlert",
            auth
              ? self.getString("Non hai l'autorizzazione")
              : error.response.data.errorMessage
          );
        })
        .finally(function () {
          // Usa `finally` correttamente
          self.loadTable2 = false;
        });
    },
    getNotificationUsers: function () {
      let self = this;
      self.loadTable = true;
      ajax.axios
        .get(
          ajax.baseUrl() +
            "/admin/calendar/shops/" +
            self.selectedShop +
            "/users/notifications",
          {
            params: {
              name: self.searchUserName.trim(),
              surname: self.searchUserSurname.trim(),
            },
            headers: {
              Authorization: "Bearer " + self.$store.getters.token,
            },
            withCredentials: true,
          }
        )
        .then(function (response) {
          ajax.validateToken(response.headers, self.$store);
          self.notificationUserList = response.data.data.users;
        })
        .catch(function (error) {
          console.log(error);
          var auth = ajax.checkAuth(error, self.$store, self.$router);
          self.$emit(
            "siteAlert",
            auth
              ? self.getString("Non hai l'autorizzazione")
              : error.response.data.errorMessage
          );
        })
        .finally(function () {
          self.loadTable = false;
        });
    },
    compileForm: function (item) {
      this.disabledCompileUserData = true;
      this.newName = item.name;
      this.newSurname = item.surname;
      this.newPhone = item.phone;
      this.newNote = item.nota;
      this.oldNote = item.nota;
      //this.waitingListCurrentIdUserSelected = item.idUser;
      if (item.servObject) {
        this.newServices = [];
        item.servObject.forEach((x) => {
          const found = this.services.find((c) => x.idPrice === c.idPrice);
          if (found) this.newServices.push(found);
        });
      }
    },
    siteAlert: function (val) {
      this.$emit("siteAlert", val);
    },
    siteAlertSuccess: function (val) {
      this.$emit("siteAlertSuccess", val);
    },
    formatTitle: function (d) {
      var options = {
        weekday: "long",
      };
      return ut.Capitalize(new Date().toLocaleString(this.locale, options));
    },
    banUser: function () {
      let self = this;
      this.isLoading = true;
      ajax.axios
        .put(
          ajax.baseUrl() +
            "/admin/calendar/ban/" +
            self.detCard.selectedCard.referenceUsers +
            "/shop/" +
            self.selectedShop,
          {},
          {
            headers: {
              Authorization: "Bearer " + self.$store.getters.token,
            },
            withCredentials: true,
          }
        )
        .then(function (response) {
          ajax.validateToken(response.headers, self.$store);
          self.isLoading = false;
          self.$emit("siteAlertSuccess", response.data.data);
          self.confirmBan = false;
          self.detailsDialog = false;
          self.detCard.popCard(self.detCard.selectedCard.idReservation);
        })
        .catch(function (error) {
          self.isLoading = false;
          var auth = ajax.checkAuth(error, self.$store, self.$router);
          self.$emit(
            "siteAlert",
            auth
              ? self.getString("Non hai l'autorizzazione")
              : error.response.data.errorMessage
          );
        });
    },
    deleteReservation: function () {
      let self = this;
      this.isLoading = true;
      ajax.axios
        .delete(
          ajax.baseUrl() +
            "/admin/calendar/reservation/" +
            self.detCard.selectedCard.idReservation,
          {
            headers: {
              Authorization: "Bearer " + self.$store.getters.token,
            },
            withCredentials: true,
          }
        )
        .then(function (response) {
          ajax.validateToken(response.headers, self.$store);
          self.isLoading = false;
          self.$emit("siteAlertSuccess", response.data.data);
          self.confirmDelete = false;
          self.confirmDeletePc = false;
          self.detailsDialog = false;
          self.detCard.popCard(self.detCard.selectedCard.idReservation);
        })
        .catch(function (error) {
          self.isLoading = false;
          var auth = ajax.checkAuth(error, self.$store, self.$router);
          self.$emit(
            "siteAlert",
            auth
              ? self.getString("Non hai l'autorizzazione")
              : error.response.data.errorMessage
          );
        });
    },
    deleteReservationAll: function () {
      let self = this;
      this.isLoading = true;
      ajax.axios
        .delete(
          ajax.baseUrl() +
            "/admin/calendar/reservation/" +
            self.detCard.selectedCard.idReservation +
            "/all",
          {
            headers: {
              Authorization: "Bearer " + self.$store.getters.token,
            },
            withCredentials: true,
          }
        )
        .then(function (response) {
          ajax.validateToken(response.headers, self.$store);
          self.isLoading = false;
          self.$emit("siteAlertSuccess", response.data.data);
          self.confirmDeletePc = false;
          self.detailsDialog = false;
          self.detCard.popCard(self.detCard.selectedCard.idReservation);
          self.ajaxPooling();
        })
        .catch(function (error) {
          self.isLoading = false;
          var auth = ajax.checkAuth(error, self.$store, self.$router);
          self.$emit(
            "siteAlert",
            auth
              ? self.getString("Non hai l'autorizzazione")
              : error.response.data.errorMessage
          );
        });
    },
    openWhatsapp: function () {
      let phone = this.detCard.selectedCard.phone;
      if (isNaN(parseInt(phone.charAt(0)))) phone = phone.slice(1);

      window.open("https://api.whatsapp.com/send?phone=" + phone, "_blank");
    },
    openNotificationDialog: function () {
      this.sendNotificationPopup = true;
      this.newNotificationBody = {
        title: "Comunicazione",
        message: "",
      };
    },
    resetNewDialog: function () {
      this.newName = "";
      this.newSurname = "";
      this.newMinute = "";
      this.newServices = [];
      this.newPhone = "";
      this.newNote = "";
      this.oldNote = "";
      this.newGlobalNote = "";
      this.newGlobalNoteAuthor = "";
      this.globalNotes = [];
      this.selectWaitingListUser = {};
      this.disabledCompileUserData = false;
      this.newRes = {
        isFirst: true,
        hour: "0",
        emp: {},
        day: "",
      };
      this.newRepeat = false;
      this.weekRepeat = 10;
      this.weekRepeatEach = 1;
      this.addNewDialog = false;
      // edit per dialog waiting list
      this.addNewDialogWaitingList = null;
    },
    details: function (card) {
      this.detCard = card;
      this.selectedService = this.detCard.selectedService
        .split(",")
        .map((service) => {
          const foundService = this.services.find(
            (item) => item.description.trim() === service.trim()
          );
          return foundService
            ? foundService
            : { price: "nd", description: service };
        });

      this.newNote = card.selectedCard.note;
      this.oldNote = card.selectedCard.note;
      this.globalNotes = [];
      if (card.selectedCard.referenceUsers > 0) this.getNotes();
      this.detailsDialog = true;
    },
    multiDetails: function (val) {
      this.multiDetailCards = val.cards;
      this.multiDetailsCardRef = val.cardRef;
      this.multiDetailsDialog = true;
    },
    getMultiCardName: function (card) {
      return ((card.uSurname || card.flySurname || "") + " " + (card.uName || card.flyName || "")).trim();
    },
    getMultiCardTime: function (card) {
      if (!card || !card.dateAndTime || !card.dateEnd) return "";
      return card.dateAndTime.split("T")[1].substring(0, 5) + " - " + card.dateEnd.split("T")[1].substring(0, 5);
    },
    getMultiCardServices: function (card) {
      const services = (card && card.service ? card.service : "")
        .split(",")
        .map((service) => service.trim())
        .filter((service) => service !== "");
      if (services.length === 0) return [this.getString("Senza servizio")];
      return services;
    },
    openFromMulti: function (index) {
      this.multiDetailsDialog = false;
      const cardRef = this.multiDetailsCardRef;
      cardRef.selectedIndex = index;
      cardRef.selectedCard = this.multiDetailCards[index];
      this.details(cardRef);
    },
    getCardBySelected: function (day, emp, hour, min) {
      let result = null;
      for (let index = 0; index < this.allCards.length; index++) {
        const element = this.allCards[index];
        if (
          element._props.day === day &&
          element._props.empId === emp &&
          element._props.hour === hour &&
          element._props.min === min
        ) {
          result = element;
          break;
        }
      }
      return result;
    },
    card: function (day, emp, hour, min, card, isNew) {
      if (isNew === undefined) isNew = false;
      let temp = this.getCardBySelected(day, emp, hour, min);
      if (temp !== null) {
        if (card.dateAndTime.split("T")[0] === temp.fullDate.split("T")[0])
          temp.pushCard(card, isNew);
      }
    },
    moveReservation: function () {
      let self = this;
      this.isLoading = true;
      let time =
        this.moveDate + "T" + this.moveHour + ":" + this.moveMin + ":00";
      let idEmp = this.moveEmp;
      let servicesText = "";
      let services = [];

      for (let index = 0; index < this.moveServices.length; index++) {
        const price = this.moveServices[index];
        const item = this.services.find((x) => x.idPrice === price.idPrice);

        servicesText = item.description + "," + servicesText;
        services.push(price.idPrice);
      }
      servicesText = servicesText.substring(0, servicesText.length - 1);
      ajax.axios
        .put(
          ajax.baseUrl() +
            "/admin/calendar/shop/" +
            self.selectedShop +
            "/reservation/" +
            self.sCard.selectedCard.idReservation,
          {
            time: time,
            idEmp: idEmp,
            servicesText: servicesText,
            services: services,
            notify: this.notifyUser,
          },
          {
            headers: {
              Authorization: "Bearer " + self.$store.getters.token,
            },
            withCredentials: true,
          }
        )
        .then(function (response) {
          ajax.validateToken(response.headers, self.$store);
          self.sCard.popCard(self.sCard.selectedCard.idReservation);
          self.isLoading = false;
          let res = response.data.data;
          let coord = self.getCardCoordByResv(res);
          self.card(coord.day, coord.emp, coord.hour, coord.min, res, false);
          self.moveInfo = false;
        })
        .catch(function (error) {
          var auth = ajax.checkAuth(error, self.$store, self.$router);
          self.isLoading = false;
          self.$emit(
            "siteAlert",
            auth
              ? self.getString("Non hai l'autorizzazione")
              : error.response.data.errorMessage
          );
        });
    },
    sendNotification: function () {
      let self = this;
      if (
        self.newNotificationBody.title.length > 50 ||
        self.newNotificationBody.message.length > 300
      ) {
        self.$emit("siteAlert", "Il messaggio è troppo lungo");
        return;
      }
      if (
        self.newNotificationBody.title.length == 0 &&
        self.newNotificationBody.message.length == 0
      ) {
        self.$emit("siteAlert", "Non è possibile inviare un messaggio vuoto");
        return;
      }
      this.isLoading = true;
      ajax.axios
        .post(
          ajax.baseUrl() +
            "/admin/communication/user/" +
            self.detCard.selectedCard.referenceUsers +
            "/shop/" +
            self.selectedShop,
          self.newNotificationBody,
          {
            headers: {
              Authorization: "Bearer " + self.$store.getters.token,
            },
            withCredentials: true,
          }
        )
        .then(function (response) {
          ajax.validateToken(response.headers, self.$store);
          self.isLoading = false;
          self.$emit("siteAlertSuccess", response.data.data.text);
          self.sendNotificationPopup = false;
        })
        .catch(function (error) {
          self.isLoading = false;
          var auth = ajax.checkAuth(error, self.$store, self.$router);
          self.$emit(
            "siteAlert",
            auth
              ? self.getString("Non hai l'autorizzazione")
              : error.response.data.errorMessage
          );
        });
    },
    addNewConfirm: function (forceAdd) {
      let self = this;
      //let data = new FormData()
      let time = this.newRes.hour + ":" + this.newMinute + ":00";
      let date = this.newRes.date.split("T")[0];

      let servicesText = "";
      let services = [];

      for (let index = 0; index < this.newServices.length; index++) {
        const price = this.newServices[index];
        const item = this.services.find((x) => x.idPrice === price.idPrice);
        servicesText = servicesText + "," + item.description;
        services.push(price.idPrice);
      }
      // console.log("services", servicesText);
      servicesText = servicesText.substring(1, servicesText.length);
      if (self.isDynamic == true && services.length === 0) {
        this.$emit(
          "siteAlert",
          this.getString("Devi configurare i servizi prima di procedere")
        );
        return;
      }
      if (services === "") {
        this.$emit("siteAlert", this.getString("Servizi mancanti"));
        return;
      }
      if (this.newMinute === "") {
        this.$emit("siteAlert", this.getString("Scegli i minuti"));
        return;
      }
      if (this.newName === "") {
        this.$emit("siteAlert", this.getString("Scegli almeno il nome"));
        return;
      }
      if (this.weekRepeat < 2 || this.weekRepeat > 50) {
        this.$emit(
          "siteAlert",
          this.getString("Devi inserire un numero tra 2 e 50")
        );
        return;
      }
      if (this.weekRepeatEach < 1 || this.weekRepeatEach > 4) {
        this.$emit(
          "siteAlert",
          this.getString("Devi inserire una ripetizione tra 1 e 4")
        );
        return;
      }
      this.isLoading = true;
      let data = {
        name: this.newName,
        surname: this.newSurname,
        phone: this.newPhone,
        note: this.newNote,
        idShop: this.selectedShop,
        idEmp: this.newRes.emp,
        idUser: this.selectWaitingListUser._isManual ? null : this.selectWaitingListUser.idUser,
        idCrmClient: this.selectWaitingListUser._isManual ? this.selectWaitingListUser.idCrmClient : null,
        servicesText: servicesText,
        services: services,
        date: date + "T" + time,
        repeat: this.newRepeat,
        weekRepeat: this.weekRepeat,
        weekRepeatEach: this.weekRepeatEach,
        forceAdd: forceAdd,
      };
     // console.log("data", data);
      ajax.axios
        .post(ajax.baseUrl() + "/admin/calendar/reservation", data, {
          headers: {
            Authorization: "Bearer " + self.$store.getters.token,
          },
          withCredentials: true,
        })
        .then(function (response) {
          ajax.validateToken(response.headers, self.$store);
          var res = response.data.data;
          self.isLoading = false;
          self.card(
            self.newRes.day,
            self.newRes.emp,
            self.newRes.hour,
            self.newMinute,
            res,
            true
          );
          self.resetNewDialog();
          self.ajaxPooling();
          // self.newName = "";
          // self.newSurname = "";
          // self.newMinute = "";
          // self.newServices = [];
          // self.newPhone = "";
          // self.newNote = "";
          // self.newRes = {
          //   isFirst: true,
          //   hour: "0",
          //   emp: {},
          //   day: "",
          // };
          // self.newRepeat = false;
          // self.weekRepeat = 10;
          // self.addNewDialog = false;
          // self.addNewConfirmDialog = false;
        })
        .catch(function (error) {
          self.isLoading = false;
          if (error.response.data.error.number === 8888) {
            self.addNewConfirmDialog = true;
          } else {
            var auth = ajax.checkAuth(error, self.$store, self.$router);
            self.$emit(
              "siteAlert",
              auth
                ? self.getString("Non hai l'autorizzazione")
                : error.response.data.errorMessage
            );
          }
        });
    },
    addNew: function (val) {
      this.newRes = val;
      this.newNote = "";
      this.addNewDialog = true;
    },
    move: function (target) {
      this.sCard = target.card;
      let date = new Moment(this.sCard.selectedCard.dateAndTime);
      this.moveMin = date.format("mm");
      const currentService = this.sCard.selectedService.split(",");
      this.moveServices = this.services.filter((x) =>
        currentService.map((s) => s.trim()).includes(x.description.trim())
      );

      this.moveHour = this.sCard.hour;
      this.moveEmp = this.sCard.empId;
      this.notifyUser = true;
      this.moveDate = date.format("YYYY-MM-DD");

      this.moveInfo = true;
    },
    appendCard: function (val) {
      val.forEach((e) => {
        this.$set(this.allCards, this.allCards.length, e);
      });
      this.loadedCells += 1;
      let count =
        this.emps.length *
        this.days.length *
        this.getDayOfWeekTimes(this.days[0].dayOfWeek).times.length;
      if (this.loadedCells >= count) {
        let temp = this.resv;
        for (let index = 0; index < temp.length; index++) {
          const element = temp[index];
          let coord = this.getCardCoordByResv(element);
          this.card(
            coord.day,
            coord.emp,
            coord.hour,
            coord.min,
            element,
            false
          );
        }
      }
    },
    scroll: function (e) {
      let temp = e.srcElement.scrollLeft;
      this.headerLeftMargin = temp; //+ (this.isFullscreen ? 33.5 : 0)
      var temp1 = this.$refs.header;
      temp1.scrollLeft = this.headerLeftMargin;
    },
    getString: function (key, values) {
      return this.$store.state.currentTranslator.getString(key, values);
    },
    openClientCard: function (card) {
      if (card.referenceCrmClient > 0) {
        this.$refs.shopUsersRef.openDetails({ idCrmClient: card.referenceCrmClient, _isManual: true });
      } else {
        this.$refs.shopUsersRef.openDetails({ idUser: card.referenceUsers, _isManual: false });
      }
    },
    onCrmClientDeleted: function (idCrmClient) {
      if (this.detCard && this.detCard.selectedCard && this.detCard.selectedCard.referenceCrmClient == idCrmClient) {
        this.detCard.selectedCard.referenceCrmClient = 0;
      }
    },
    defaultAvatar: function (item) {
      if (item !== undefined) {
        if (
          item.photo === null ||
          item.photo === "/images/u_placeholder.jpg" ||
          item.photo === "images/u_placeholder.jpg" ||
          item.photo === undefined
        ) {
          item.photo = "/../../../static/img/default-avatar.png";
          return item.photo;
        } else
          var photoUrl = item.photo.startsWith('http') ? item.photo : ajax.baseUrl() + item.photo;
          return photoUrl + "?t=" + new Date().getSeconds();
      }
      return;
    },
    getPrices: function () {
      let self = this;
      ajax.axios
        .get(
          ajax.baseUrl() + "/admin/shops/shop/" + self.selectedShop + "/prices",
          {
            headers: self.$store.getters.tokenHeader,
            withCredentials: true,
          }
        )
        .then(function (response) {
          ajax.validateToken(response.headers, self.$store);
          self.services = response.data.data.prices;
          self.mainLoad = false;
          self.initPooling();
        })
        .catch(function (error) {
          var auth = ajax.checkAuth(error, self.$store, self.$router);
          self.$emit(
            "siteAlert",
            auth
              ? self.getString("Non hai l'autorizzazione")
              : error.response.data.errorMessage
          );
        });
    },
    getDayName: function (day, date) {
      return (
        this.getString(ut.getDayName(day)) +
        " " +
        date.split("-")[2] +
        " " +
        this.getString(ut.getMonthName(date.split("-")[1]))
      );
    },
    isClosed: function (day) {
      let temp = true;
      for (let index = 0; index < this.times.length; index++) {
        const element = this.times[index];
        if (element.day === day) {
          temp = false;
          break;
        }
      }
      return temp;
    },
    getDayOfWeekTimes: function (dayOfWeek, ide) {
      let result = null;
      for (let index = 0; index < this.times.length; index++) {
        const element = this.times[index];
        if (element.day === dayOfWeek) {
          if (
            element.empOverride.length > 0 &&
            ide &&
            element.empOverride.filter((x) => x.id === ide).length > 0
          ) {
            result = element.empOverride.filter((x) => x.id === ide)[0];
          } else {
            // console.log(ide);
            result = element;
          }
        }
      }
      return result;
    },
    deselectOnly: function () {
      this.sCard = null;
      this.moveHour = "";
      this.moveMin = "";
      this.moveEmp = "";
      this.moveInfo = false;
    },
    clearSelected: function () {
      if (this.sCardRef !== null) {
        this.sCardRef.popCard(this.sCard.idReservation);
        this.sCardRef = null;
      }
      this.sCard = null;
    },
    resetCards: function () {
      // for (let index = 0; index < this.allCards.length; index++) {
      //   const element = this.allCards[index]
      //   element.reset()
      // }
    },
    resetAll: function () {
      let self = this;
      self.times = [];
      self.minTime = "00:00";
      self.maxTime = "23:59";
      self.days = [];
      self.resv = [];
      self.emps = [];
      self.services = [];
      self.allCards = [];
      self.loadedCells = 0;
    },
    getTimesArray: function () {
      this.mainLoad = true;
      let self = this;
      this.resetCards();
      ajax.axios
        .get(
          ajax.baseUrl() +
            "/admin/calendar/shop/" +
            self.selectedShop +
            "/opentimes/" +
            self.startDate,
          {
            headers: self.$store.getters.tokenHeader,
            withCredentials: true,
          }
        )
        .then(function (response) {
          ajax.validateToken(response.headers, self.$store);
          self.times = response.data.data.times;
          self.minTime = response.data.data.min;
          self.maxTime = response.data.data.max;
          self.isDynamic = response.data.data.isDynamic;
          self.busyMinutes = response.data.data.busyMinutes;
          self.poolAudio = "/static/audio/" + response.data.data.sound;
          self.poolAudioDelete =
            "/static/audio/" + response.data.data.soundDelete;
          self.getResv();
        })
        .catch(function (error) {
          var auth = ajax.checkAuth(error, self.$store, self.$router);
          self.$emit(
            "siteAlert",
            auth
              ? self.getString("Non hai l'autorizzazione")
              : error.response.data.errorMessage
          );
        });
    },
    getEmpArray: function () {
      let self = this;
      let lastDay = self.days[self.days.length - 1].day.split("T")[0];
      ajax.axios
        .get(
          ajax.baseUrl() +
            "/admin/shops/shop/" +
            self.selectedShop +
            "/employees/notAvailable/" +
            lastDay,
          {
            headers: self.$store.getters.tokenHeader,
            withCredentials: true,
          }
        )
        .then(function (response) {
          ajax.validateToken(response.headers, self.$store);
          self.emps = response.data.data;
          self.getPrices();
        })
        .catch(function (error) {
          var auth = ajax.checkAuth(error, self.$store, self.$router);
          self.$emit(
            "siteAlert",
            auth
              ? self.getString("Non hai l'autorizzazione")
              : error.response.data.errorMessage
          );
        });
    },
    getResv: function (date) {
      let self = this;
      ajax.axios
        .get(
          ajax.baseUrl() +
            "/admin/calendar/shop/" +
            self.selectedShop +
            "/reservations/" +
            self.startDate,
          {
            headers: self.$store.getters.tokenHeader,
            withCredentials: true,
          }
        )
        .then(function (response) {
          ajax.validateToken(response.headers, self.$store);
          self.days = response.data.data.days;
          self.resv = response.data.data.reservations;
          self.getEmpArray();
        })
        .catch(function (error) {
          var auth = ajax.checkAuth(error, self.$store, self.$router);
          self.$emit(
            "siteAlert",
            auth
              ? self.getString("Non hai l'autorizzazione")
              : error.response.data.errorMessage
          );
        });
    },
    getCardCoordByResv: function (res) {
      let card = {
        day: res.dateAndTime.split("T")[0].split("-")[2],
        emp: res.referenceEmployee,
        hour: res.dateAndTime.split("T")[1].split(":")[0],
        min: this.roundMin(res.dateAndTime.split("T")[1].split(":")[1]),
      };
      return card;
    },
    roundMin: function (ns) {
      var x = Math.floor(Number.parseInt(ns) / 5) * 5;
      if (x <= 5) return "0" + x;
      return "" + x;
    },
    toogleFullscreen: function () {
      if (this.copied === false) {
        let els = document.querySelectorAll("#main-shell > .v-menu__content");
        let temp = document.getElementById("cal-container");
        let index = 0;
        for (let index = 0; index < els.length; index++) {
          const element = els[index];
          if (element.querySelectorAll(".v-select-list").length > 0) {
            temp = temp.appendChild(els[index]).parentNode;
          }
        }
        this.copied = true;
      }

      let element = document.getElementById("cal-container");
      if (fscreen.fullscreenElement === null) {
        fscreen.requestFullscreen(element);
      } else {
        fscreen.exitFullscreen();
      }
    },
    fsChange: function (e) {
      this.$store.commit("toggleFullscreen");
    },
    stripHtml: function (html) {
      // Create a new div element
      var temporalDivElement = document.createElement("div");
      // Set the HTML content with the providen
      temporalDivElement.innerHTML = html;
      // Retrieve the text property of the element (cross-browser support)
      return (
        temporalDivElement.textContent || temporalDivElement.innerText || ""
      );
    },
  },
};
</script>

<style scoped>
.multi-res-body {
  padding: 16px;
  background: linear-gradient(180deg, #fff8f1 0%, #ffffff 100%);
}

.multi-res-toolbar-title {
  display: inline-flex;
  align-items: center;
}

.multi-res-intro {
  display: flex;
  justify-content: space-between;
  align-items: stretch;
  gap: 12px;
  margin-bottom: 16px;
  padding: 14px 16px;
  border-radius: 14px;
  background: #fff3e0;
  border: 1px solid #ffe0b2;
}

.multi-res-intro-title {
  font-size: 18px;
  font-weight: 700;
  color: #bf6d1b;
}

.multi-res-intro-subtitle {
  margin-top: 4px;
  font-size: 13px;
  color: #8a6b4b;
  max-width: 420px;
}

.multi-res-stats {
  display: flex;
  gap: 10px;
}

.multi-res-stat-card {
  min-width: 88px;
  padding: 10px 12px;
  border-radius: 12px;
  background: white;
  border: 1px solid #ffe0b2;
  text-align: center;
}

.multi-res-stat-number {
  font-size: 22px;
  font-weight: 700;
  color: #e67e22;
}

.multi-res-stat-label {
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.6px;
  color: #9c7b5d;
}

.multi-res-group {
  margin-bottom: 14px;
  border: 1px solid #f1e1cf;
  border-radius: 16px;
  overflow: hidden;
  background: white;
  box-shadow: 0 10px 24px rgba(186, 126, 54, 0.08);
}

.multi-res-group-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  padding: 14px 16px;
  background: linear-gradient(90deg, #fff7ed 0%, #fffdf8 100%);
  border-bottom: 1px solid #f6e4d2;
}

.multi-res-group-title {
  font-size: 16px;
  font-weight: 700;
  color: #8d5524;
}

.multi-res-group-subtitle {
  margin-top: 2px;
  font-size: 12px;
  color: #a37d58;
}

.multi-res-row {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  border-bottom: 1px solid #f5ede4;
  cursor: pointer;
  transition: background 0.15s, transform 0.15s;
}

.multi-res-row:last-child {
  border-bottom: 0;
}

.multi-res-row:hover {
  background: #fff8ee;
}

.multi-res-avatar-wrap {
  flex-shrink: 0;
}

.multi-res-avatar {
  width: 48px;
  height: 48px;
  border-radius: 14px;
  object-fit: cover;
  display: block;
}

.multi-res-main {
  flex: 1;
  min-width: 0;
}

.multi-res-name-row {
  display: flex;
  align-items: center;
  gap: 8px;
}

.multi-res-name {
  font-size: 15px;
  font-weight: 600;
  color: #3b2a1a;
}

.multi-res-meta-row {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 5px;
  font-size: 12px;
  color: #8d7a66;
}

.multi-res-time {
  font-weight: 600;
  color: #bf6d1b;
}

.multi-res-dot {
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background: #d5a77c;
}

.multi-res-phone {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.multi-res-action {
  flex-shrink: 0;
}

@media (max-width: 700px) {
  .multi-res-intro {
    flex-direction: column;
  }

  .multi-res-stats {
    width: 100%;
  }

  .multi-res-stat-card {
    flex: 1;
  }

  .multi-res-meta-row {
    flex-wrap: wrap;
  }
}

.counter {
  text-align: right;
  margin-top: 10px;
  color: #666;
  transition: color linear 0.3s;
}

.warning-message {
  padding: 5px;
}

.counter-red {
  color: tomato;
}

.hours-col {
  padding-top: 70px;
  flex-direction: column;
  display: flex;
  text-align: center;
  padding-left: 5px;
  padding-right: 5px;
}

.hours-col h4 {
  /* flex-grow: 1; */
}

.bar {
  margin-bottom: -35px;
  transition: margin-bottom 0.2s linear;
  -o-transition: margin-bottom 0.2s linear;
  -ms-transition: margin-bottom 0.2s linear;
  -webkit-transition: margin-bottom 0.2s linear;
  -moz-transition: margin-bottom 0.2s linear;
}

.bar:hover {
  margin-bottom: 0;
}

.main-headers {
  display: flex;
  flex-direction: row;
  z-index: 10;
  margin-top: -10px;
  width: 100%;
  overflow: hidden;
  height: 30px;
  z-index: 1;
}

.main-headers-full {
  display: flex;
  flex-direction: row;
  position: fixed;
  z-index: 10;
  margin-top: 0;
  width: 100%;
}

.main-flex {
  display: flex;
  flex-direction: row;
  height: calc(100vh - 165px);
  overflow: scroll;
  margin-top: 0px;
  border-top: solid thin #ccc;
}

.main-flex-full {
  display: flex;
  flex-direction: row;
  height: calc(100vh - 30px);
  overflow: scroll;
  margin-top: 25px;
}

#cal-container {
  /* width: 100%; */
  margin-left: 40px;
  background: var(--background-color);
}

/* @media screen and (max-width: 700px) {
  #cal-container {
    margin-left: 0;
  }
} */

.col-day-flex {
  display: flex;
  flex-direction: row;
}

.col-flex {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  border: solid thin #000;
}

.col-emp {
  width: 280px;
  padding-bottom: 20px;
}

.col-emp-collapsed {
  width: 50px !important;
}

.header-item {
  flex-grow: 0;
  flex-shrink: 0;
}

.odd-bk {
  background-color: var(--odd-bk);
}

.even-bk {
  background-color: var(--even-bk);
}

.t-field {
  margin-right: 10px;
}

.avatar-img {
  width: 280px;
  height: 250px;
  object-fit: cover;
  border-radius: 4px;
  border: solid 5px #f57c00;
  box-shadow: 0 0 5px #000 !important;
}
.avatar-img-small {
  width: 100%;
  max-height: 250px;

  object-fit: cover;
  transition: max-height 0.3s ease-in-out;
  border: solid 5px #f57c00;
  box-shadow: 0 0 5px #000 !important;
}

.ban {
  cursor: pointer;
}

.dedicate-triangle {
  margin-right: 10px;
  transform: rotate(90deg);
  border-bottom: solid 10px rgb(36, 163, 100);
  border-right: solid 5px transparent;
  border-left: solid 5px transparent;
}

.dedicate-triangle-w {
  margin-right: 10px;
  transform: rotate(90deg);
  border-bottom: solid 10px transparent;
  border-right: solid 5px transparent;
  border-left: solid 5px transparent;
}

.feature-list {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  width: 0px;
  padding: 5px;
}

.settings-btn-fixed {
  position: fixed;
  bottom: 64px;
  left: 0;
  z-index: 100;
  padding: 5px;
}

.overlay {
  height: 82%;
}

.box-container {
  background: white !important;
  padding: 10px;
  border-radius: 10px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1), 0 1px 3px rgba(0, 0, 0, 0.08);
}
.darkMode .box-container {
  background: #424242 !important;
}

.container {
}

.btn-operation {
  width: 150px;
}

/* Reservation notification tray */
.res-notify-tray {
  position: fixed;
  bottom: 80px;
  right: 20px;
  z-index: 9999;
  display: flex;
  flex-direction: column;
  gap: 10px;
  max-width: 380px;
  width: 100%;
 
}

.res-notify-card {
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0,0,0,0.18);
  overflow: hidden;
  background: #fff;
}

.res-notify-new {
  border-left: 5px solid #43a047;
  margin: 5px;
}

.res-notify-del {
  border-left: 5px solid #e53935;
  margin: 5px;
}

.res-notify-header {
  display: flex;
  align-items: center;
  padding: 10px 12px 6px;
  background: rgba(0,0,0,0.03);
  gap: 6px;
}

.res-notify-new .res-notify-icon {
  color: #43a047 !important;
}

.res-notify-del .res-notify-icon {
  color: #e53935 !important;
}

.res-notify-title {
  font-weight: 700;
  font-size: 13px;
  flex: 1;
  letter-spacing: 0.3px;
}

.res-notify-close {
  margin: 0 !important;
  opacity: 0.6;
}

.res-notify-item {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 7px 14px;
  cursor: pointer;
  transition: background 0.15s;
  border-top: 1px solid rgba(0,0,0,0.06);
}

.res-notify-item:hover {
  background: rgba(0,0,0,0.05);
}

.res-notify-new .res-notify-item-icon {
  color: #43a047 !important;
}

.res-notify-del .res-notify-item-icon {
  color: #e53935 !important;
}

.res-notify-name {
  font-weight: 600;
  font-size: 16px;
  flex: 1;
}

.res-notify-date {
  font-size: 13px;
  color: #888;
  white-space: nowrap;
}

.res-notify-fade-enter-active,
.res-notify-fade-leave-active {
  transition: all 0.3s ease;
}

.res-notify-fade-enter,
.res-notify-fade-leave-to {
  opacity: 0;
  transform: translateX(40px);
}

/* Center the "Visualizza il nuovo pannello" button inside the alert */
.new-panel-alert-row {
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 12px;
}
.new-panel-alert-row .center-btn {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
}
</style>



// WEBPACK FOOTER //
// src/components/backend/Calendar.vue